import { filter, map, take, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services';
import {
  ButtonStyle,
  ModalConfirmComponent
} from './../../../components/system/modal-confirm/modal-confirm.component';
import { ToastrService } from 'ngx-toastr';
import {
  Component,
  OnInit,
  AfterViewInit,
  EventEmitter,
  Input,
  ViewChild,
  OnDestroy,
  Inject,
  forwardRef,
  HostListener,
  Directive,
  SimpleChanges,
  ChangeDetectorRef,
  TemplateRef,
  ElementRef
} from '@angular/core';
import {
  WorkflowContextService,
  WorkflowService,
  SecurityService
} from '../../../services';
import {
  ActivityStatus,
  Activity,
  ActivityModel,
  FormActivityModel,
  ContinuousActivity
} from '../../../models/activities';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { Role, Actions, ApplicationStatus } from '../../../models';
import { ApplicationInputComponent } from '../../workflow/application-input/application-input.component';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationExtras,
  NavigationEnd,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Subscription, forkJoin, Subject } from 'rxjs';
import { StartApplicationResponse } from '../../../models/start-application-response';
import { PreviousRouteService } from '../../../services/previous-route';
import { ActivityNavigationInfo } from 'src/app/models/activity-navigation-Info';
import { FeeDataEntity } from 'src/app/models/data-entities';
import { DatePipe } from '@angular/common';
import { CloseApplicationRequest } from 'src/app/models/close-application-request';
import { GPErrorHandler } from 'src/app/services/gp-error';
import { ActivityViewComponent } from 'src/app/components/workflow/activities/activity-editor/activity-view/activity-view.component';
import { WorkflowTestAsClientComponent } from 'src/app/components/workflow/workflow-test-as-client/workflow-test-as-client.component';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';
import { WorkflowApplicationsJanusService } from '../../admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';
import { RenewalsJanusService } from 'src/app/components/renewals/renewals-janus/renewals-janus.service';
import { LayoutService } from 'src/app/services/layout.service';
import { Images, svgs } from 'src/assets/export.assets';
import { TableStateService } from '../../applicant/my-applications/table-state-service';
import { MyApplicationsService } from '../../applicant/my-applications/my-applications.service';
// Added by Amisha on 2026-06-12.
// Reason: let AppView participate in shared route-leave protection for Janus-only flows.
import { ComponentCanDeactivate } from 'src/app/services/pending-changes.guard';
import { AppViewLeaveConfirmationService } from 'src/app/services/app-view-leave-confirmation.service';
import { ContractorRefreshService } from '../../applicant/my-contractor-registration/my-contractor-registations.refresh.service';

// import { URL, URLSearchParams } from 'url';
@Directive()
export class ActivityView {
  @Input({}) activity: Activity<ActivityModel>;
  @Input() isPreview: boolean;
  isTestApplication: boolean;
  showSave?: EventEmitter<boolean> = new EventEmitter<boolean>();
  showCancel?: EventEmitter<boolean> = new EventEmitter<boolean>();
  showNext?: EventEmitter<boolean> = new EventEmitter<boolean>();
  showPrevious?: EventEmitter<boolean> = new EventEmitter<boolean>();
  goNext?: EventEmitter<boolean> = new EventEmitter<boolean>();
  save?: EventEmitter<boolean> = new EventEmitter<boolean>();
  switchApplication?: EventEmitter<string> = new EventEmitter<string>();
  onRefreshApp?: EventEmitter<void> = new EventEmitter<void>();

  value$: EventEmitter<any> = new EventEmitter<any>();
  initActivity;
  @Input() form: UntypedFormGroup;
  context: WorkflowContextService;
  nextOnSelect = false;
  applicationId?: string;
  refreshView?: EventEmitter<void> = new EventEmitter<void>();
  async persistChildComponent?() {
    return new Promise(resolve => {
      resolve(null);
    });
  }
  viewTitle(): string {
    if (this.activity && this.activity.model) {
      return this.activity.summaryLabel || this.activity.model.screenName;
    } else {
      return 'unknown';
    }
  }
}

@Component({
  selector: 'wm-app.view',
  templateUrl: './app.view.component.html',
  styleUrls: ['./app.view.component.css'],
  standalone: false
})
export class AppViewComponent
  implements OnInit, AfterViewInit, OnDestroy, ComponentCanDeactivate {
  // Added by Vipul on 14-01-2026
  private pendingApplicationId: string | null = null;
  // Added by Amisha on 2026-06-12.
  // Reason: track pending Janus-only confirmations for step changes and route exits.
  private pendingStepNavigationActivityId: string | null = null;
  private skipRouteLeaveConfirmationOnce = false;
  private routeLeaveConfirmationPromise: Promise<boolean> | null = null;
  private routeLeaveConfirmationResolver:
    | ((shouldLeave: boolean) => void)
    | null = null;
  public svgs = svgs;
  private readonly contractorViewDestroyed$ = new Subject<void>();
  private isContractorViewDestroyed = false;
  private isContractorRegistrationView = false;
  private queryParamMapSubscription: Subscription;
  showCloseIcon: boolean = true;
  infoIcon = svgs.infoIcon.name;
  private isSaving = false;//added by priya on 03-09-2026

  @ViewChild(ApplicationInputComponent)
  set applicationInput(comp: ApplicationInputComponent) {
    if (!comp) return;

    const isRecreated = this.appInput && this.appInput !== comp;

    this.appInput = comp;

    if (this.pendingApplicationId) {
      const id = this.pendingApplicationId;
      this.pendingApplicationId = null;
      this.loadApplication(id);
    } else if (isRecreated && this.applicationId) {
      setTimeout(() => {
        this.loadApplication(this.applicationId);
      });
    }
  }

  appInput!: ApplicationInputComponent;
  // End by Vipul on 14-01-2026

  // Added by Vipul Rathod on 30-07-2026
  private openTestWorkflowModal$ = new Subject<void>();
  // Added by Vipul Rathod on 30-07-2026
  buttonStyles = ButtonStyle;

  @Input({ required: false }) activity: Activity<ActivityModel>;
  @Input({ required: false }) isPreview: boolean;
  @Input({ required: false }) role: Role;
  @Input({ required: false }) form: UntypedFormGroup;
  @ViewChild('newDocument', { static: false }) modal: ModalConfirmComponent;
  @ViewChild('requiredDocumentsModal', { static: false })
  requiredDocumentsModal: ModalConfirmComponent;
  @ViewChild('closeApplicationModal', { static: true })
  closeApplicationModal: ModalConfirmComponent; // Deepak 2026-03-02 changed a false to true for modal open  for jansu Style
  @ViewChild('testAsClientModal', { static: true })
  testAsClientModal: WorkflowTestAsClientComponent;

  showTestWorkflowModal = false; // Added by Vipul on 29-07-2026

  //added by furkan for fixing save & exit menu panel size
  public menuWidths: { [key: string]: number } = {};
  // Added by Amisha on 2026-08-17.
  // Reason: avoid reading offsetWidth when a conditional menu wrapper is unavailable.
  public setDynamicMenuWidth(
    element: HTMLElement | undefined,
    menuId: string
  ): void {
    setTimeout(() => {
      if (!element) {
        return;
      }

      this.menuWidths[menuId] = element.offsetWidth;
    });
  }
  //ebded by furkan for fixing save & exit menu panel size

  applicationId: string;
  workflowName: string;
  applicationNumber: string;
  clientApplicationNumber: string;
  workflowId: string;
  versionId: string;
  isTestApplication: boolean;
  isTestContractorWorkflow = false; // Code added by Sanchit on 07/15/2026
  shouldShowSave = false;
  shouldShowCancel: boolean;
  shouldShowVoid = false;
  shouldShowNext = true;
  shouldShowPrevious = true;
  canUseSave = false;
  canUsePrevious = false;
  canUseNext = false;
  canUseCancelDiscard = false;
  couldUsePrevious: boolean;
  couldUseNext: boolean;
  couldUseCancelDiscard: boolean;
  couldUseSave: boolean;
  isLastActivity = false;
  processing = false;
  viewTitle: string;
  roleSubscription: Subscription;
  appIdSubscription: Subscription;
  testRoles: Role[];
  selectedRole: string;
  hasFees = false;
  navigationItems: ActivityNavigationInfo[];
  callWorkflowsParentApplicationList: ActivityNavigationInfo[];
  fees: FeeDataEntity[];
  submitterId: string;
  activitySetNextState = false;
  summaryActivities: Activity<ActivityModel>[];
  activityDataId: string;
  returnURL: string;

  loadingExit = false;
  loadingSave = false;
  loadingDiscard = false;
  loading = false;
  isMobileDevice = false;
  menuOpen = false;
  // Added by Amisha on 2026-08-31.
  // Reason: track the expanded state of the compact Janus mobile footer actions.
  mobileActionsOpen = false;
  now = Date.now();
  pipe = new DatePipe('en-US');
  //added by priya 2025-11-04
  openStepperModal = false;

  //end 2025-11-04

  nextProcessing = false; //added by priya 08-01-2026

  closeWorkflowApplicationForm: UntypedFormGroup = new UntypedFormGroup({
    closeReason: new UntypedFormControl('', [Validators.required]),
    closeDateTime: new UntypedFormControl({
      value: this.pipe.transform(this.now, 'MM/dd/yyyy h:mm:ss a'),
      disabled: true
    }),
    closedBy: new UntypedFormControl({
      value: this.context.user ? this.context.user.userName : '',
      disabled: true
    })
  });

  canEditNotes: boolean;
  canViewVersion: boolean;
  application = null;
  canEditApplicationNumber = false;
  applicationProcessing = false;
  requestedCloseStatus: ApplicationStatus;
  closeApplicationText: string = '';
  templateForPermitForm = false;
  useNewLayout1: boolean = false;

  private autoSubmitComplete = false;
  private browserBackConfirmed = false; // Code added by Sanchit on 12/06/2026
  // Added by Amisha on 2026-09-29.
  // Reason: track and clean up the shared staff mobile scroll frame without changing applicant layout.
  private inlineExpansionContent: HTMLElement | null = null;
  private inlineExpansionResizeObserver: ResizeObserver | null = null;

  constructor(
    public layoutService: LayoutService,
    @Inject(forwardRef(() => WorkflowContextService))
    public context: WorkflowContextService,
    private _route: ActivatedRoute,
    @Inject(forwardRef(() => WorkflowService))
    private _workflowSvc: WorkflowService,
    @Inject(forwardRef(() => DataService))
    private _dataSvc: DataService,
    private _router: Router,
    private _previousRouteSvc: PreviousRouteService,
    private toastr: ToastrService,
    @Inject(forwardRef(() => SecurityService))
    private _securitySvc: SecurityService,
    private _errorHandler: GPErrorHandler,
    private cd: ChangeDetectorRef,
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private renewalsJanusSvc: RenewalsJanusService,
    private scrollService: TableStateService,
    public myApplicationsService: MyApplicationsService,
    private appViewLeaveConfirmationService: AppViewLeaveConfirmationService,
    private refreshSvc: ContractorRefreshService,
    private hostElement: ElementRef<HTMLElement>
  ) {
    //added by priya 2025-11-04
    const nav = this._router.getCurrentNavigation();
    const navState = nav?.extras?.state as
      | { useNewLayout?: boolean }
      | undefined;

    layoutService.useNewLayout$.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(useNewLayout => {
      this.templateForPermitForm = useNewLayout;
    });

    //end by priya 2025-11-04
  }
  //added by priya 2025-11-12
  get showPosition(): boolean {
    return (
      this.myApplicationsService.isInProgressOverlay &&
      this.context.janusLayout === 'applicant'
    );
  }

  get showBottomPadding(): boolean {
    return (
      this.myApplicationsService.isInProgressOverlay &&
      this.context.janusLayout === 'applicant' &&
      !this._router.url.includes('my-contractor-registrations')
    );
  }

  toggleStepperModal() {
    this.openStepperModal = !this.openStepperModal;
  }

  get isStepperOpen() {
    return WorkflowContextService.isStepperOpen;
  }

  set isStepperOpen(value: boolean) {
    WorkflowContextService.isStepperOpen = value;
  }

  toggleStaffStepper(): void {
    this.isStepperOpen = !this.isStepperOpen;
  }

  closeStepper() {
    WorkflowContextService.isStepperOpen = false;
    const el1 = document.querySelector(
      '.header-parent-container'
    ) as HTMLElement;
    if (el1) {
      el1.style.zIndex = '99';
    }
  }
  //end by priya 2025-11-12

  closeIcon = 'assets/images/close.svg';
  closeSvgIcon = svgs.closeIcon.name;

  get closeReason() {
    return this.closeWorkflowApplicationForm.get('closeReason');
  }

  appInputLoaded: boolean = false;

  // here to make sure the child components have loaded before the Next and Save buttons can be enabled
  ngDoCheck(): void {
    if (this.appInput != null && this.appInput.activityContainerLoaded) {
      this.appInputLoaded = true;
    } else {
      this.appInputLoaded = false;
    }

    // Added by Amisha on 2026-06-26.
    // Reason: keep the shared Janus leave-confirmation service updated as the
    // active AppView form moves between pristine and dirty states.
    this.syncJanusLeaveProtectionState();
  }

  ngOnDestroy(): void {
   // Keep this fix scoped to the staff contractor view. Use its initial route:
    // the router may already point to another module when destruction runs.
    if (this.isContractorRegistrationView) {
      this.isContractorViewDestroyed = true;
      this.contractorViewDestroyed$.next();
    }
    this.contractorViewDestroyed$.complete();
    // Added by Amisha on 2026-09-29.
    // Reason: remove staff-only scroll ownership and measured height when App View closes.
    this.inlineExpansionResizeObserver?.disconnect();
    this.inlineExpansionResizeObserver = null;
    this.inlineExpansionContent?.classList.remove('app-view-scroll-owner');
    this.inlineExpansionContent = null;
    this.hostElement.nativeElement.classList.remove(
      'staff-mobile-scroll-app-view-host'
    );
    this.hostElement.nativeElement.classList.remove(
      'staff-overlay-app-view-host'
    );
    this.hostElement.nativeElement.style.removeProperty('height');
    if (this.queryParamMapSubscription) {
      this.queryParamMapSubscription.unsubscribe();
      this.queryParamMapSubscription = null;
    }
    // Added by Amisha on 2026-06-12.
    // Reason: resolve any open Janus leave-confirmation promise so navigation
    // cannot remain stuck if AppView is destroyed mid-flow.
    if (this.routeLeaveConfirmationResolver) {
      this.resolveRouteLeaveConfirmation(false);
    }

    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
      this.roleSubscription = null;
    }

    if (this.appIdSubscription) {
      this.appIdSubscription.unsubscribe();
      this.appIdSubscription = null;
    }

    if (this.appInput) {
      this.appInput.applicationId = null;
    }

    // Added by Amisha on 2026-06-26.
    // Reason: clear the shared Janus unsaved-changes flag when AppView is
    // destroyed so later shell navigation starts from a clean state.
    this.appViewLeaveConfirmationService.setUnsavedChangesEvaluator(null);
    this.appViewLeaveConfirmationService.setUnsavedChanges(false);
    this.context.viewAsRole$.emit(null);

    // Added by Priya on 17-09-2026
    if (this.context.janusLayout === 'applicant') {
      // Remove mobile route-body styles when leaving App View.
      this.removeMobileRouteBodyStyle()
      window.removeEventListener('resize', this.resizeHandler);
      
    }
  }

  private resizeTimer: any;
  @HostListener('window:resize')
  onWindowResizeForApplicant(): void {
    // Added by Priya on 17-09-2026
    // Handle mobile route-body styling to fix scrolling when App View is loaded directly.
    if (this.context.janusLayout === 'applicant'){
     
      const isAppViewRoute =
        this._router.url.includes(
          `/${applicantHomeRoutesNames.applyForPermit.route}/department/`
        ) &&
    (
      this._router.url.includes(
          `/${applicantHomeRoutesNames.application.route}/`
        ) ||
          this._router.url.includes(
            `/${applicantHomeRoutesNames.childApplication.route}/`
      )
    );

      if (isAppViewRoute) {
        if (window.innerWidth <= 767) {
          this.setMobileRouteBodyStyle();
        } else {
          this.removeMobileRouteBodyStyle();
        }
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.isMobile();
      // Updated by Amisha on 2026-08-31.
      // Reason: prevent the mobile SAVE label from remaining after resizing to laptop/desktop.
      this.isMobileNavigationSaveButton();
      this.menuOpen = !this.isMobileDevice;
      // Added by Amisha on 2026-08-31.
      // Reason: reset the compact footer after leaving its Janus <=394px scope.
      if (!this.isJanusMobileView) {
        this.mobileActionsOpen = false;
      }
    }, 300);
  }

  // Added by Amisha on 2026-08-31.
  // Reason: close compact footer actions on outside clicks while preserving Save menu/modal interactions.
  @HostListener('document:click', ['$event'])
  closeMobileActions(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    const isActionOverlayClick = target?.closest(
      '.dynamic-width-menu, .modal-backdrop'
    );

    if (isActionOverlayClick) {
      return;
    }

    if (this.mobileActionsOpen) {
      this.mobileActionsOpen = false;
    }
  }

  // Start Code added by Sanchit on 12/06/2026
  @HostListener('window:popstate', ['$event'])
  onBrowserBack(event: PopStateEvent) {
    if (!this.isJanusAppViewFlow()) {
      return;
    }

    if (this.browserBackConfirmed) {
      return;
    }

    history.pushState(null, '', location.href);

    this.openBrowserBackModal(); // Existing Close modal
  }

  browserBackModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to leave this page?',
    modalSubDescp: 'Changes you made may not be saved.',
    yesNoBtn: true,
    replaceYesWith: 'LEAVE',
    replaceNoWith: 'STAY'
  };

  openBrowserBackModal = () => {
    this.browserBackModalData = {
      ...this.browserBackModalData,
      open: true
    };

    this.cd.detectChanges();
  };

  closeBrowserBackModal = () => {
    this.browserBackModalData = {
      ...this.browserBackModalData,
      open: false
    };

    this.cd.detectChanges();
  };

  leavePageFromBrowserBack = () => {
    this.browserBackConfirmed = true;

    this.browserBackModalData = {
      ...this.browserBackModalData,
      open: false
    };

    if (this._router.url.includes('renewals')) {
      this.closeRenewalInline();
      return;
    }

    this.closeApplication();
  };
  // End Code added by Sanchit on 12/06/2026

  mainClick() {
    if (this.menuOpen) {
      this.menuOpen = !this.menuOpen;
    }
  }

  @ViewChild('wizardButtons') wizardButtons!: ElementRef;
  // Added by Priya on 17-09-2026
  // Apply mobile route-body styles when directly navigating to App View.

  private setMobileRouteBodyStyle(): void {
    if (window.innerWidth <= 767) {
      const scrollEl = document.querySelector('.route-body') as HTMLElement;
      const mainBody = document.querySelector(
        '.main-body-container'
      ) as HTMLElement;

      if (scrollEl) {
        scrollEl.style.maxWidth = 'none';

      }

      if (mainBody) {
                mainBody.style.maxHeight = 'calc(100dvh - 220px)'

        mainBody.style.display = 'block';


      }
    }
  }

  // Added by Priya on 17-09-2026
  // Resize handler for app-view (applicant)

  private resizeHandler = (): void => {
    this.onWindowResizeForApplicant();
  };

  // Added by Priya on 17-09-2026
  // Remove mobile route-body styles when leaving App View.
  private removeMobileRouteBodyStyle(): void {
    const scrollEl = document.querySelector('.route-body') as HTMLElement;
    const mainBody = document.querySelector(
      '.main-body-container'
    ) as HTMLElement;

    if (scrollEl) {
      scrollEl.style.maxWidth = '1700px';

    }

    if (mainBody) {
                mainBody.style.maxHeight = '100%'
      mainBody.style.display = 'flex';
    }
    
  }

  // Janus: Submit is a separate button (isLastActivity), so this only decides
  // UPDATE vs NEXT. The server sends "Update" only for a completed activity the
  // user can edit and that has something to edit.
  get nextButtonLabel(): string {
    return this.activity?.processButtonText === 'Update' ? 'UPDATE' : 'NEXT';
  }

  // GeoPermits: a single button for Submit / Update / Next. Uses the server's
  // text (Activity.SetProcessButtonProperties) and never returns an empty label.
  get processButtonLabel(): string {
    const text = (this.activity?.processButtonText || '').trim();
    if (text) {
      return text;
    }
    return this.isLastActivity ? 'Submit' : 'Next';
  }

  ngAfterViewInit() {
    // Added by Amisha on 2026-09-29.
    // Reason: initialize body-only scrolling for staff mobile inline and overlay App Views.
    this.configureStaffMobileScrollLayout();

    if (this.context.janusLayout === 'applicant') {
      window.addEventListener('resize', this.resizeHandler);

      setTimeout(() => {
        this.onWindowResizeForApplicant();
      }, 300);
      //Added by priya on 10-09-2026
      // Calculate the wizard button height dynamically so the scrollable content
      // can reserve space for the fixed navigation buttons in Applicant View.
      const observer = new ResizeObserver(() => {
        const height = this.wizardButtons?.nativeElement?.offsetHeight || 0;

        document.documentElement.style.setProperty(
          '--wizard-buttons-height',
          `${height}px`
        );
      });

      if (this.wizardButtons) {
        observer.observe(this.wizardButtons.nativeElement);
      }
    }
    //added by priya 2025-11-04
    this.toggleCanvas();
    //end by priya 2025-11-04
  }

  // Added by Amisha on 2026-09-29.
  // Reason: calculate the exact staff mobile App View height so only its form body scrolls;
  // applicant flows return before any class or inline height is applied.
  private configureStaffMobileScrollLayout(): void {
    const isInlineStaffAppView =
      this.context?.janusLayout === 'staff' &&
      (this.context?.applicationViewType === 'inline' ||
        this._route.snapshot.queryParamMap.get('showAppView') === '1' ||
        !this.showCloseIcon);

    const expansionContent = this.hostElement.nativeElement.closest(
      '.mobile-inline-expansion-content'
    ) as HTMLElement | null;
    const applicationOverlay = this.hostElement.nativeElement.closest(
      '.new-application-overlay'
    ) as HTMLElement | null;
    const isOverlayStaffAppView =
      this.context?.janusLayout === 'staff' &&
      this.context?.applicationViewType === 'overlay' &&
      !!applicationOverlay;
    const scrollFrame = expansionContent || applicationOverlay;

    if ((!isInlineStaffAppView && !isOverlayStaffAppView) || !scrollFrame) {
      return;
    }

    if (expansionContent) {
      this.inlineExpansionContent = expansionContent;
      expansionContent.classList.add('app-view-scroll-owner');
    }

    this.hostElement.nativeElement.classList.add(
      'staff-mobile-scroll-app-view-host'
    );
    if (isOverlayStaffAppView) {
      this.hostElement.nativeElement.classList.add(
        'staff-overlay-app-view-host'
      );
    }

    const updateAvailableHeight = () => {
      if (!window.matchMedia('(max-width: 767px)').matches) {
        this.hostElement.nativeElement.style.removeProperty('height');
        return;
      }

      const contentRect = scrollFrame.getBoundingClientRect();
      const hostRect = this.hostElement.nativeElement.getBoundingClientRect();
      const availableHeight = Math.max(
        0,
        Math.floor(contentRect.bottom - hostRect.top)
      );

      this.hostElement.nativeElement.style.height = `${availableHeight}px`;
    };

    updateAvailableHeight();
    requestAnimationFrame(updateAvailableHeight);

    this.inlineExpansionResizeObserver = new ResizeObserver(
      updateAvailableHeight
    );
    this.inlineExpansionResizeObserver.observe(scrollFrame);
  }
  //added by priya 2025-11-04

  ngOnChanges(changes: SimpleChanges) {
    if (changes['templateForPermitForm']) {
      this.toggleCanvas();
    }
  }
  private toggleCanvas() {
    const body = document.body;
    if (this.templateForPermitForm) {
      body.classList.add('hide-bmd-canvas');
    } else {
      body.classList.remove('hide-bmd-canvas');
    }
  }

  //end by priya 2025-11-04

  // Added by Amisha on 2026-06-12.
  // Reason: all intentional AppView-owned exits should bypass the Janus shell
  // leave warning so only direct user shell navigation gets intercepted.
  private navigateWithoutLeavePrompt(
    commands: any[],
    extras?: NavigationExtras
  ): Promise<boolean> {
    this.skipRouteLeaveConfirmationOnce = true;

    return this._router
      .navigate(commands, {
        ...extras,
        state: {
          ...(extras?.state || {}),
          skipAppViewLeaveConfirmation: true
        }
      })
      .finally(() => {
        this.skipRouteLeaveConfirmationOnce = false;
      });
  }

  // Added by Amisha on 2026-06-12.
  // Reason: suppress the Janus leave prompt when navigation stays inside AppView.
  private isNavigatingToAnotherAppView(
    nextState?: RouterStateSnapshot
  ): boolean {
    let routeSnapshot = nextState?.root ?? null;

    while (routeSnapshot) {
      if (routeSnapshot.routeConfig?.component === AppViewComponent) {
        return true;
      }

      routeSnapshot = routeSnapshot.firstChild ?? null;
    }

    return false;
  }

  // Added by Amisha on 2026-06-12.
  // Reason: keep the new route-leave and step-navigation prompts strictly limited to Janus flows.
  private isJanusAppViewFlow(): boolean {
    return (
      this.context?.janusLayout === 'staff' ||
      this.context?.janusLayout === 'applicant'
    );
  }

  // Added by Amisha on 2026-07-09.
  // Reason: keep the AppView-side unsaved check focused on the current form
  // state only, without blurring the active input during normal typing.
  private hasUnsavedChanges(): boolean {
    return this.appInput?.form?.dirty === true;
  }

  // Added by Amisha on 2026-07-09.
  // Reason: register a live evaluator with the shared Janus confirmation
  // service so leave checks can refresh dirty state only at navigation time.
  private syncJanusLeaveProtectionState(): void {
    this.appViewLeaveConfirmationService.setUnsavedChangesEvaluator(
      () => this.isJanusAppViewFlow() && this.hasUnsavedChanges()
    );
    this.appViewLeaveConfirmationService.setUnsavedChanges(
      this.isJanusAppViewFlow() && this.hasUnsavedChanges()
    );
  }

  // Added by Amisha on 2026-06-12.
  // Reason: centralize cleanup for the Janus route-leave modal promise and UI state.
  private resolveRouteLeaveConfirmation(shouldLeave: boolean): void {
    const resolver = this.routeLeaveConfirmationResolver;

    this.routeLeaveConfirmationResolver = null;
    this.routeLeaveConfirmationPromise = null;
    this.routeLeaveModalData = {
      ...this.routeLeaveModalData,
      open: false
    };

    resolver?.(shouldLeave);
  }

  // Added by Amisha on 2026-06-12.
  // Reason: after the user confirms, allow the pending Janus route exit and
  // clear the shared AppView state once navigation actually finishes.
  confirmRouteLeave(): void {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this.context.applicationViewType$.emit('none');
      });

    this.resolveRouteLeaveConfirmation(true);
  }

  // Added by Amisha on 2026-06-12.
  // Reason: close the Janus route-leave modal and keep the current AppView open.
  cancelRouteLeave(): void {
    this.resolveRouteLeaveConfirmation(false);
  }

  // Added by Amisha on 2026-06-12.
  // Reason: AppView controls Janus-only route exit confirmation while still
  // allowing non-Janus flows and internal AppView transitions to proceed normally.
  canDeactivate(
    _currentRoute?: ActivatedRouteSnapshot,
    _currentState?: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Promise<boolean> {
    if (!this.isJanusAppViewFlow()) {
      return true;
    }

    if (
      this.skipRouteLeaveConfirmationOnce ||
      this.isNavigatingToAnotherAppView(nextState) ||
      !this.hasUnsavedChanges()
    ) {
      return true;
    }

    if (this.routeLeaveConfirmationPromise) {
      return this.routeLeaveConfirmationPromise;
    }

    this.routeLeaveModalData = {
      ...this.routeLeaveModalData,
      open: true
    };
    this.cd.detectChanges();

    this.routeLeaveConfirmationPromise = new Promise<boolean>(resolve => {
      this.routeLeaveConfirmationResolver = resolve;
    });

    return this.routeLeaveConfirmationPromise;
  }

  async persistChildComponent() {
    return this.appInput.persistChildComponent();
  }
  get isJanusContractorRegistration(): boolean {
    const path = this._router.url.split(/[?#]/)[0];
    return this.templateForPermitForm &&
      this.context?.janusLayout === 'staff' &&
      /^\/admin\/jurisdiction\/[^/]+\/department\/[^/]+\/contractors\/all(?:\/|$)/.test(path);
  }

  changeActivity(activity: Activity<ActivityModel>) {
    this.processing = false;
    this.activity = activity;
    this.shouldShowNext = this.isJanusContractorRegistration
      ? activity.shouldShowNext && activity.showProcessButton !== false
      : activity.shouldShowNext;
    this.shouldShowPrevious = true;
    this.canUsePrevious = this.activity.canGoPrevious; // this.activity.previousActivityId != null;
    this.canUseNext = this.activity.canGoNext; // true; // this is here to reset the next button and let the next activity control it from there.
    this.canUseCancelDiscard = true;
    this.canUseSave =
      !(this.isPreview || false || this.isTestApplication || false) &&
      this.activity.status !== ActivityStatus.Completed;
    this.shouldShowSave =
      (this.canUseSave || this.isTestApplication || false) &&
      activity.showSaveButton;
  }

  refreshUser() {
    if (this.context.user) {
      this._securitySvc.getUser(this.context.user.id).subscribe(user => {
        this.context.user$.emit(user);
      });
    }
  }

  retrieveSummary() {
    this.summaryActivities = null;
    this._workflowSvc
      .getCompletedActivities(this.applicationId)
      .subscribe(activities => {
        this.summaryActivities = activities;
      });
  }

  retrieveApplication() {
    this.application = null;
    this._securitySvc
      .isLoginEntitled(Actions.WORKFLOW_APPLICATIONS_EDIT)
      .subscribe(result => {
        this.canEditNotes = result;
      });
    return this._dataSvc.getApplicationSummary(this.applicationId).pipe(
      map(summary => {
        this.application = summary.application;
        return summary;
      })
    );
  }

  openApplicationWorkflowBuilder() {
    this.retrieveApplication().subscribe(summary => {
      const workflowId = summary.workflowId;
      const versionId = summary.workflowVersionId;

      this.modal.cancel();

      this.navigateWithoutLeavePrompt([
        '/admin/workflow-builder/',
        workflowId,
        versionId,
        this.application.id
      ]);
    });
  }

  changeRole(e) {
    if (this.context.viewAsRole !== e) {
      this.context.viewAsRole$.emit(
        this.testRoles.find(
          r => r.id.toLowerCase() === this.selectedRole.toLowerCase()
        )
      );
    }
  }
  getSelectedRoleName(): string {
    return this.testRoles?.find(r => r.id === this.selectedRole)?.name || '';
  }
  openRoleMenu = false;

  toggleRoleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.openRoleMenu = !this.openRoleMenu;
  }

  onRoleSelect(role: any): void {
    this.selectedRole = role.id;

    // Reuse your existing method
    this.changeRole(role.id);

    this.openRoleMenu = false;
  }

  disableButtons() {
    // capture state of the buttons for potential re-enabling
    this.couldUsePrevious = this.canUsePrevious;
    this.couldUseNext = this.canUseNext;
    this.couldUseCancelDiscard = this.canUseCancelDiscard;
    this.couldUseSave = this.canUseSave;

    this.canUsePrevious = false;
    this.canUseNext = false;
    this.canUseCancelDiscard = false;
    this.canUseSave = false;
  }

  reenableButtons() {
    this.canUsePrevious = this.couldUsePrevious;
    this.canUseNext = this.couldUseNext;
    this.canUseCancelDiscard = this.couldUseCancelDiscard;
    this.canUseSave = this.couldUseSave;
  }

  // Added by Amisha on 2026-06-12.
  // Reason: route stepper clicks through a Janus-only confirmation flow before
  // switching activities, while keeping non-Janus behavior unchanged.
  requestStepNavigation(activityDataId: string): void {
    if (!activityDataId || activityDataId === this.activity?.activityDataId) {
      return;
    }

    if (!this.isJanusAppViewFlow()) {
      this.navigate(activityDataId);
      return;
    }

    // Added by Amisha on 2026-06-26.
    // Reason: stepper clicks within Janus should only prompt after the user
    // has actually edited the current activity form.
    if (!this.hasUnsavedChanges()) {
      this.navigate(activityDataId);
      return;
    }

    this.pendingStepNavigationActivityId = activityDataId;
    this.stepNavigationModalData = {
      ...this.stepNavigationModalData,
      open: true
    };
    this.cd.detectChanges();
  }

  // Added by Amisha on 2026-06-12.
  // Reason: cancel a pending Janus stepper navigation and close the modal.
  cancelStepNavigation(): void {
    this.pendingStepNavigationActivityId = null;
    this.stepNavigationModalData = {
      ...this.stepNavigationModalData,
      open: false
    };
    this.cd.detectChanges();
  }

  // Added by Amisha on 2026-06-12.
  // Reason: resume the requested Janus stepper navigation after confirmation.
  confirmStepNavigation(): void {
    const activityDataId = this.pendingStepNavigationActivityId;

    this.cancelStepNavigation();

    if (!activityDataId) {
      return;
    }

    this.navigate(activityDataId);
  }

  navigate(activityDataId: string) {
    this.processing = true;
    this.disableButtons();
    const navAD = this.navigationItems.find(
      ni =>
        ni.activityDataId &&
        ni.activityDataId.toLowerCase() == activityDataId.toLowerCase()
    );
    if (navAD) {
      if (navAD.canNavigate) {
        this.appInput.navigateToActivity(activityDataId);
      } else {
        this.toastr.warning('The activity you requested is not available.');
      }
    }
  }

  getFormGroupErrors(fg: UntypedFormGroup): string[] {
    let errors: string[];

    if (fg.errors) {
      const keys = Object.keys(fg.errors);

      errors = keys.map((value, index) => {
        return '';
      });
    }

    return errors;
  }

  getVoidButtonData(template: TemplateRef<any>) {
    return {
      text: template
    };
  }

  private validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  nexter() {
    this.persistChildComponent().then(value => { });
  }

  //added by furkan 2026-01-12
  //scroll to top on next click
  private scrollToTopDeep(frames = 3) {
    const resetOnce = () => {
      try {
        // window / document resets
        try {
          window.scrollTo({ top: 0, behavior: 'auto' });
        } catch (e) {
          window.scrollTo(0, 0);
        }
        document.documentElement && (document.documentElement.scrollTop = 0);
        document.body && (document.body.scrollTop = 0);

        // Useful selectors we know about
        const knownSelectors = [
          '#mainContent',
          '#stepperContent',
          '#wizardContent',
          '.stepper-modal',
          '.bmd-layout-content',
          '.container-fluid',
          '.wizard-content',
          '.stepper-content',
          '.activity-container',
          '.application-input'
        ];

        const nodes = new Set<HTMLElement>();

        // add known targets if present
        knownSelectors.forEach(sel => {
          const el = document.querySelector(sel) as HTMLElement;
          if (el) nodes.add(el);
        });

        // add any elements that appear scrollable (limits to reasonable number)
        const all = Array.from(document.querySelectorAll<HTMLElement>('*'));
        for (let i = 0, len = all.length; i < len && nodes.size < 200; i++) {
          const el = all[i];
          const style = window.getComputedStyle(el);
          const overflowY = style.overflowY;
          if (
            el.scrollHeight > el.clientHeight &&
            overflowY !== 'visible' &&
            overflowY !== 'hidden'
          ) {
            nodes.add(el);
          }
        }

        // Finally reset scrollTop and call scrollIntoView on first child to ensure start-of-content
        nodes.forEach(el => {
          try {
            if (el.scrollTo) {
              el.scrollTo(0, 0);
            } else {
              el.scrollTop = 0;
            }

            // If there is an inner element, bring that into view at the top
            const firstChild = el.querySelector<HTMLElement>(
              '*:not(script):not(style)'
            );
            if (firstChild && typeof firstChild.scrollIntoView === 'function') {
              firstChild.scrollIntoView({
                block: 'start',
                inline: 'nearest',
                behavior: 'auto'
              });
            }
          } catch (err) {
            // ignore per-element failures
          }
        });
      } catch (err) { }
    };

    // perform across a few animation frames and a fallback timeout tick to catch async DOM updates
    let executed = 0;
    const step = () => {
      if (executed >= frames) return;
      executed++;
      requestAnimationFrame(() => {
        resetOnce();
        // also schedule a micro task fallback
        setTimeout(() => {
          resetOnce();
        }, 0);
        // schedule next frame
        if (executed < frames) {
          setTimeout(step, 20);
        }
      });
    };
    step();
  }

  private scrollToFirstInvalid() {
    // allow DOM updates from validation marking to finish
    requestAnimationFrame(() => {
      try {
        // gather elements that Angular marks as invalid
        const allInvalid = Array.from(
          document.querySelectorAll<HTMLElement>('.ng-invalid')
        );

        // prefer visible invalid elements (offsetParent null => hidden)
        const visibleInvalid = allInvalid.find(el => {
          const rect = el.getBoundingClientRect();
          const visible =
            rect.width > 0 && rect.height > 0 && el.offsetParent !== null;
          return visible;
        });

        // fallback: attribute-based invalid (some libs set aria-invalid)
        const ariaInvalid = document.querySelector<HTMLElement>(
          '[aria-invalid="true"]'
        );

        let targetEl: HTMLElement | null = null;

        // choose best candidate
        const candidate = visibleInvalid || ariaInvalid || allInvalid[0];
        if (candidate) {
          // try to focus an inner control first
          targetEl =
            candidate.querySelector<HTMLElement>(
              'input, textarea, select, [tabindex]'
            ) || candidate;
        }

        if (targetEl) {
          // scroll element to center of viewport   smoother UX for user seeing the field
          try {
            targetEl.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          } catch (err) {
            // some hosts may not support options
            targetEl.scrollIntoView();
          }

          // focus the input control if possible (preventScroll to avoid another jump)
          try {
            (targetEl as HTMLElement).focus({ preventScroll: true });
          } catch (e) {
            try {
              (targetEl as HTMLElement).focus();
            } catch {
              /* ignore */
            }
          }
          return;
        }

        // nothing matched   fall back to top reset
        this.scrollToTopDeep(2);
      } catch (err) {
        this.scrollToTopDeep(2);
      }
    });
  }
  //ended by furkan on 2026-01-12

  private scrollToFirstInvalidJanus() {
    setTimeout(() => {
      try {
        const fieldWrappers = Array.from(
          document.querySelectorAll<HTMLElement>(
            'wm-data-entity-input, wm-list-data-entity-input, wm-document-data-entity-input, wm-calculate-value-data-entity-input, wm-numeric-data-entity-input, wm-free-form-text-data-entity-input, wm-rich-text-data-entity-input'
          )
        );

        fieldWrappers.forEach(wrapper => {
          const formEl = wrapper.querySelector('form');

          if (formEl) {
            const wmDeLabel = formEl.querySelector('wm-de-label');
            const wmUpload = formEl.querySelector('wm-upload');

            if (wmDeLabel && wmUpload) {
              const hasAsterisk = wmDeLabel.textContent?.includes('*');

              if (hasAsterisk) {
                const listItems = wmUpload.querySelectorAll('.list-group-item');
                const fileInput = wmUpload.querySelector<HTMLInputElement>(
                  'input[type="file"]'
                );

                if (listItems.length === 0) {
                  if (fileInput && fileInput.parentElement) {
                    let errorSpan = fileInput.parentElement.querySelector<
                      HTMLSpanElement
                    >('.upload-required-error');
                    if (!errorSpan) {
                      errorSpan = document.createElement('span');
                      errorSpan.className = 'upload-required-error';
                      errorSpan.textContent = 'Required';
                      errorSpan.style.color = 'red';
                      errorSpan.style.display = 'block';
                      errorSpan.style.marginTop = '4px';
                      errorSpan.style.marginLeft = '0px';
                      const uploadButton =
                        fileInput.parentElement.querySelector(
                          '.upload-button'
                        ) ||
                        fileInput.parentElement.querySelector(
                          'wm-common-button'
                        ) ||
                        fileInput.parentElement.querySelector('button');

                      if (uploadButton) {
                        const wrapper = document.createElement('div');
                        wrapper.style.display = 'flex';
                        wrapper.style.flexDirection = 'column';
                        wrapper.style.alignItems = 'flex-start';

                        uploadButton.parentNode?.insertBefore(
                          wrapper,
                          uploadButton
                        );
                        wrapper.appendChild(uploadButton);
                        wrapper.appendChild(errorSpan);
                      } else {
                        fileInput.insertAdjacentElement('afterend', errorSpan);
                      }
                    }
                  }
                  wrapper.classList.add('custom-missing-upload');
                } else {
                  if (fileInput && fileInput.parentElement) {
                    const errorSpan = fileInput.parentElement.querySelector<
                      HTMLSpanElement
                    >('.upload-required-error');
                    if (errorSpan) {
                      errorSpan.remove();
                    }
                  }
                  wrapper.classList.remove('custom-missing-upload');
                }
              }
            }
          }
        });

        const firstInvalidField = fieldWrappers.find(wrapper => {
          // Changes done by Vipul on 16-09-2026 for PER2-8219
          const formEl = wrapper.querySelector('form');

          if (!formEl) {
            return false;
          }

          const invalidControl = wrapper.querySelector(`
            input.ng-invalid:not([type="hidden"]),
            textarea.ng-invalid,
            select.ng-invalid,
            wm-common-textfield.ng-invalid,
            wm-common-dropdown.ng-invalid,
            wm-common-radio.ng-invalid,
            wm-common-checkbox.ng-invalid
          `);

          const checkboxes = wrapper.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
          );

          if (checkboxes.length > 0) {
            const anyChecked = Array.from(checkboxes).some(
              checkbox => checkbox.checked
            );

            const label = formEl.querySelector('wm-de-label');

            const isRequired =
              label?.textContent?.includes('*') ?? false;

            if (isRequired && !anyChecked) {
              return this.isElementVisible(wrapper);
            }
          }

          if (invalidControl) {
            return this.isElementVisible(wrapper);
          }

          if (wrapper.classList.contains('custom-missing-upload')) {
            return this.isElementVisible(wrapper);
          }

          return false;
          // End Changes done by Vipul on 16-09-2026 for PER2-8219
        });

        if (firstInvalidField) {
          try {
            firstInvalidField.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
            // Changes done by Vipul on 16-09-2026 for PER2-8219
            setTimeout(() => {
              const inputToFocus =
                firstInvalidField.querySelector<HTMLElement>(
                `
                  input:not([type="hidden"]):not([disabled]),
                  textarea:not([disabled]),
                  select:not([disabled]),
                  button:not([disabled]),
                  [tabindex]:not([tabindex="-1"])
                  `
              );

              if (inputToFocus) {
                inputToFocus.focus({
                  preventScroll: true
                });
              }
            }, 300);
            return;
            // End Changes done by Vipul on 16-09-2026 for PER2-8219
          } catch (err) {
            firstInvalidField.scrollIntoView();
          }

          const inputToFocus = firstInvalidField.querySelector<HTMLElement>(
            'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );

          if (inputToFocus) {
            try {
              inputToFocus.focus({ preventScroll: true });
            } catch (e) {
              try {
                inputToFocus.focus();
              } catch { }
            }
          }
          return;
        }

      } catch (err) {
        this.scrollToTopDeep(2);
      }
    }, 150);
  }

  // Added by Vipul on 16-09-2026 for PER2-8219
  private isElementVisible(element: HTMLElement): boolean {
    const rect = element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      element.offsetParent !== null
    );
  }
  // End by Vipul on 16-09-2026 for PER2-8219

  next() {
    this.persistChildComponent().then(value => {
      if (this.appInput && this.appInput.form.invalid) {
        this.validateAllFormFields(this.appInput.form);
        // scroll to first invalid input
        this.scrollToFirstInvalid();
        return;
      } else if (this.appInput && this.appInput.form.valid) {
        this.processing = true;
        // reset the nav buttons and let the next activity control it from here
        this.disableButtons();

        this.appInput.committed(this.activity).subscribe(a => {
          if (a.refreshUser) {
            this.refreshUser();
          }

          this.applicationNumber = a.applicationNumber;
          this.clientApplicationNumber = a.clientApplicationNumber;
        });
      }
    });
  }
  // added by priya 01-04-2026

  @ViewChild('activityTop') activityTop!: ElementRef;
  scrollToTop() {
    if (this.context?.janusLayout === 'applicant' && this.activityTop) {
      this.activityTop.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
  // end by priya 01-04-2026

  private scrollContractorApplicationToTop(): void {
    if (!this.templateForPermitForm || this.context?.janusLayout !== 'staff') {
      return;
    }

    // Wait for the next activity to render, then scroll only its owning table.
    requestAnimationFrame(() => {
      const activityTop = this.activityTop?.nativeElement as HTMLElement | undefined;
      const wrapper = activityTop?.closest<HTMLElement>('.table-wrapper');
      const row = activityTop?.closest<HTMLElement>('.inline-expanded-row');
      if (!wrapper || !row || !activityTop.isConnected) {
        return;
      }

      const header = wrapper.querySelector('thead');
      const headerHeight = header?.getBoundingClientRect().height || 0;
      wrapper.scrollTo({
        top: wrapper.scrollTop + row.getBoundingClientRect().top -
          wrapper.getBoundingClientRect().top - headerHeight,
        behavior: 'smooth'
      });
    });
  }

  // added by priya 06-01-2026
  //when templateForPermitForm is true(when there is janus styling this next click will trigger)
  handleNextClick() {
    this.persistChildComponent().then(() => {
      this.validateAllFormFields(this.appInput.form);

      if (!this.appInput) return;

      this.validateAllFormFields(this.appInput.form);
      if (this.appInput.form.invalid) {
        this.scrollToFirstInvalidJanus();
        return;
      }

      this.nextProcessing = true;
      this.disableButtons();

      this.appInput.committed(this.activity).subscribe(a => {
        if (a?.navigateToParent === true) {
          return;
        }
        if (a.refreshUser) {
          this.refreshUser();
        }

        this.applicationNumber = a.applicationNumber;
        this.clientApplicationNumber = a.clientApplicationNumber;

        this.nextProcessing = false;

        const lastNav = this.navigationItems?.[this.navigationItems.length - 1];
        const isAutoSubmit = lastNav ? !lastNav.isEnd : false;
        const allCompleted =
          this.navigationItems?.length > 0 &&
          this.navigationItems.every(nav => nav.completed);
        const UpActivty = this.activity.type;
        if (isAutoSubmit && allCompleted && UpActivty != 'wait-activity') {
          this.autoSubmitComplete = true;
          this.reenableButtons();
          this.submitOpenModal();
          return;
        }

        this.workflowApplicationsJanusSvc.setData({
          ...this.workflowApplicationsJanusSvc.getData(),
          scrollToExpandedRow: true
        });
        if (this.context.janusLayout === 'applicant') {
          this.scrollToTop();
          this.myApplicationsService.setData({
            ...this.myApplicationsService.getCurrentData(),
            reRunSummaryApi: true
          });
        } else if (this._router.url.includes('contractors')) {
          this.scrollContractorApplicationToTop();
        } else {
          this.scrollToTopDeep(4);
        }
      });
    });
  }
  updateParentWorkflowsList = (appId: string): boolean | null => {
    // check if id is present in list or not
    if (
      !this.callWorkflowsParentApplicationList?.some(
        app => app.applicationId === appId
      )
    ) {
      return null;
    }
    let isParent = false;
    if (appId === this.callWorkflowsParentApplicationList[0].applicationId) {
      isParent = true;
      this.callWorkflowsParentApplicationList = [];
      this.context.isJanusChildWorkflowCalled$.emit(false);
    } else {
      isParent = false;
      this.callWorkflowsParentApplicationList = this.callWorkflowsParentApplicationList.filter(
        app => app.applicationId !== appId
      );
    }
    return isParent;
  };

  //when templateForPermitForm is true(when there is janus styling this submit click will trigger)

  handleSubmitClick() {
    this.persistChildComponent().then(() => {
      this.validateAllFormFields(this.appInput.form);

      if (!this.appInput) return;

      if (this.appInput.form.invalid) {
        this.validateAllFormFields(this.appInput.form);
        this.scrollToFirstInvalid();
        return;
      }

      this.processing = true;
      this.disableButtons();

      this.appInput.committed(this.activity).subscribe(a => {
        if (this.isJanusContractorRegistration && a?.navigateToParent === true) {
          return;
        }
        if (a.refreshUser) {
          this.refreshUser();
        }

        if (this.context.janusLayout === 'staff') {
          // Added by amisha on 05-03-2026 for handling submit click for renewal application in staff janus layout
          // HANDLE SUBMIT FOR RENEWALS
          if (this._router.url.includes('renewals')) {
            this.closeRenewalInline();
            return;
          }

          if (this._router.url.includes('/contractors/all/application/')) {
            this.returnToContractorRegistrations();
            return;
          }

          if (this.isJanusContractorRegistration) {
            this.closeContractorRenewalInline();
            return;
          }

          // handle on submit click for workflow-applications
          if (this._router.url.includes('workflow-applications')) {
            this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
          }

          if (this.isTestContractorWorkflow) {
            this.returnToContractorTypeEdit();
            return;
          }
        } else if (this.context.janusLayout === 'applicant') {
          if (this.tryReturnToLinkedApplicationOrigin()) {
            return;
          }
          const currentData = this.myApplicationsService.getCurrentData();
          this.myApplicationsService.setData({
            ...currentData,
            reRunSummaryApi: true
          });
          // added by priya 10-04-2026
          const currentUrl = this._router.url;
          const urlSegments = this._router.url.split('/');

          const contractorRoute = urlSegments.includes(
            applicantHomeRoutesNames.myContractorRegistrations.route
          );

          if (currentUrl.includes('applicant-home/application')) {
            this.navigateWithoutLeavePrompt([
              '/jurisdiction',
              this.context.client.id,
              applicantHomeRoutesNames.root,
              applicantHomeRoutesNames.myApplications.route
            ]);
          } else if (contractorRoute) {
            this.navigateWithoutLeavePrompt(
              [
                '/jurisdiction',
                this.context.client.id,
                applicantHomeRoutesNames.root,
                applicantHomeRoutesNames.myContractorRegistrations.route
              ],
              {
                queryParamsHandling: 'preserve'
              }
            ).then(() => {
              this.refreshSvc.refresh();
            });
          } else {
            // Updated by Amisha on 2026-06-15.
            // Reason: applicant renewals submit exits should bypass the Janus
            // shell leave prompt because AppView is closing itself here.
            this.navigateWithoutLeavePrompt(
              [
                '/jurisdiction',
                this.context.client.id,
                applicantHomeRoutesNames.root,
                applicantHomeRoutesNames.myApplications.route
              ],
              {
                queryParamsHandling: 'preserve'
              }
            ).then(() => {
              this.myApplicationsService.triggerRefresh();
            });
          }
          // end by priya 10-04-2026
        }

        this.scrollToTopDeep(4);
      });
    });
  }
  // end by priya 06-01-2026
  // Added by amisha on 23-02-2026 for handling close click for renewal application in staff janus layout
  private closeRenewalInline(): void {
    // Added by Amisha on 2026-07-24.
    // Reason: return from a Renewals child workflow to its parent without collapsing the inline table expansion.
    if (this._route.snapshot.queryParamMap.get('isChild') === '1') {
      const parentApplicationId =
        this.callWorkflowsParentApplicationList?.[
          this.callWorkflowsParentApplicationList.length - 1
        ]?.applicationId || this._route.snapshot.queryParamMap.get('id');
      const parentListResult = parentApplicationId
        ? this.updateParentWorkflowsList(parentApplicationId)
        : true;

      this.navigateWithoutLeavePrompt([], {
        relativeTo: this._route,
        queryParams: {
          isChild: parentListResult === false ? 1 : null,
          cid: parentListResult === false ? parentApplicationId : null,
          showAppView: 1
        },
        queryParamsHandling: 'merge'
      });
      return;
    }

    const currentPage = this._route.snapshot.queryParamMap.get('p');

    this.renewalsJanusSvc.setData({
      ...this.renewalsJanusSvc.getData(),
      reRunJanusApplicationDataTable: true
    });
    this.context.applicationViewType$.emit('none');
    this.navigateWithoutLeavePrompt([], {
      relativeTo: this._route,
      queryParams: {
        p: currentPage || null,
        id: null,
        registrationId: null, // Code added by Sanchit on 12/06/2026
        view: null, // Code added by Sanchit on 12/06/2026
        activityDataId: null,
        workflowId: null,
        workflowVersionId: null,
        isTest: null,
        showAppView: null
      },
      queryParamsHandling: 'merge'
    });
  }

  // added by ketan 29-12-2025
  // ------------------------
  onCloseIconClick = () => {
    if (this.isTestApplication) {
      this.exitTestApplication();
      return;
    }
    this.openModal();
    if (this.context.janusLayout === 'staff') {
    } else if (this.context.janusLayout === 'applicant') {
    } else {
      return;
    }
  };
  // -----------------------
  // ended by ketan 29-12-2025

  childSaved() {
    this.processing = true;
    this.loadApplication(this.applicationId);
  }

  save(exit: boolean) {
    if (this.saveAndExitModalData.open) {
      this.saveAndExitModalData = {
        ...this.saveAndExitModalData,
        open: false
      };
    }
    //Added by priya on 03-09-2026
    // Skip automatic activity navigation while saving the current activity.
    if (!exit && this.context.janusLayout === 'applicant') {
      this.isSaving = true
      this._router.navigate([], {
        relativeTo: this._route,
        queryParams: {
          skipActivityNavigation: true
        },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }

    this.loadingSave = true;
    this.disableButtons();
    this.persistChildComponent().then(value => {
      if (
        !this.appInput ||
        !this.appInput.form ||
        !this.appInput.form.controls[
          ActivityViewComponent.SAVE_VALIDATION_GROUP_KEY
        ] ||
        this.appInput.form.controls[
          ActivityViewComponent.SAVE_VALIDATION_GROUP_KEY
        ].valid
      ) {
        const nav = () => {
          if (exit) {
            if (this.context.janusLayout === 'staff') {
              // Added by amisha on 05-03-2026 for handling exit click for renewal application in staff janus layout
              if (this._router.url.includes('renewals')) {
                this.closeRenewalInline();
                return;
              }
              if (this._router.url.includes('/contractors/all/application/')) {
                this.returnToContractorRegistrations();
                return;
              }
              // handle on save and exit click for workflow-applications
              if (this._router.url.includes('workflow-applications')) {
                this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
              }
              if (this._router.url.includes('/contractors/all')) {
                this.closeContractorRenewalInline();
                return;
              }
            } else {
              // added by priya 10-04-2026
              // Updated by Amisha on 2026-05-11:
              // use the final templateForPermitForm flag here so Save & Exit
              // follows the same Janus/non-Janus decision as the rendered UI.
              if (
                this.context.janusLayout === 'applicant' &&
                this.templateForPermitForm
              ) {
                this.myApplicationsService.selectedApplicationId = null;

                this.scrollService.enableRestore();

                this._route.data.subscribe(data => {
                  if (data.type === 'child-application') {
                    this.handleChildWorkflowNavigationOfApplicant();
                  } else {
                    this.handleDefaultNavigationOfApplicant();
                  }
                });
              }
              // end by priya 10-04-2026
              else {
                this.navigateToReferrer();
              }
            }
          } else {
            this.loadingSave = false;
            this.processing = true;
            // this.loadApplication(this.applicationId);
          }
        };

        if (this.activity && this.activity.canEdit) {
          this.appInput.saved(this.activity).subscribe(response => {
            if (response.saveSuccess) {
              this.toastr.success('Saved!', null, {
                positionClass: 'toast-top-center'
              });

              nav();
            } else {
              const saveFailTitle = 'Could not save activity.';

              if (response.loadApplicationSummary) {
                this.toastr.info(
                  `This application has been ${ApplicationStatus[response.applicationStatus]
                  }.`,
                  saveFailTitle,
                  { disableTimeOut: true }
                );

                // load current activity
                nav();
              } else if (response.longApplicationProcessEncountered) {
                this.toastr.info(
                  'Due to another action taken, this application is currently processing.  Please wait while the process finishes.  Note that depending on the nature of the action that was already processing, it is possible this application may no longer be In Progress when that action finishes.',
                  saveFailTitle,
                  { disableTimeOut: true }
                );

                // load current activity
                nav();
              } else if (response.activityWasCompleted) {
                this.toastr.info(
                  'Another action taken in this application has completed this activity.  The current data is now showing.',
                  saveFailTitle,
                  { disableTimeOut: true }
                );

                // load this activity in its current state
                this.navigate(this.activity.activityDataId);
              } else if (response.activityWasCanceled) {
                this.toastr.info(
                  'The activity you tried to save has been canceled by another action taken in this application.',
                  saveFailTitle,
                  { disableTimeOut: true }
                );

                // load current activity
                nav();
              } else {
                // uncategorized save failure on server
                this.toastr.info(
                  'Please contact support if this issue persists.',
                  saveFailTitle,
                  { disableTimeOut: true }
                );

                // load this activity in its current state
                this.navigate(this.activity.activityDataId);
              }
            }
          });
        } else {
          nav();
        }
      } else {
        this.reenableButtons();

        this.loadingSave = false;
      }
    });
  }

  private tryReturnToLinkedApplicationOrigin(): boolean {
    const isLinkedAppParam = this._route.snapshot.queryParamMap.get(
      'isLinkedApp'
    );
    const originIdParam = this._route.snapshot.queryParamMap.get('originId');
    const originDeptIdParam = this._route.snapshot.queryParamMap.get(
      'originDeptId'
    );
    const originRouteParam = this._route.snapshot.queryParamMap.get(
      'originRoute'
    );

    const isLinkedLaunch =
      (isLinkedAppParam === '1' && !!originIdParam) ||
      (this.context.isLinkedApplicationLaunch &&
        !!this.context.linkedApplicationOriginId);

    if (!isLinkedLaunch) {
      return false;
    }

    const originId = originIdParam || this.context.linkedApplicationOriginId;
    const originDeptId =
      originDeptIdParam || this.context.linkedApplicationOriginDeptId;
    const originRoute =
      originRouteParam ||
      this.context.linkedApplicationOriginRoute ||
      applicantHomeRoutesNames.applyForPermit.route;

    this.context.isLinkedApplicationLaunch = false;
    this.context.linkedApplicationOriginId = null;
    this.context.linkedApplicationOriginDeptId = null;
    this.context.linkedApplicationOriginRoute = null;

    const {
      isLinkedApp: _isLinkedApp,
      originId: _originId,
      originDeptId: _originDeptId,
      originRoute: _originRoute,
      ...cleanQueryParams
    } = this._route.snapshot.queryParams;

    this.myApplicationsService.setData({
      ...this.myApplicationsService.getCurrentData(),
      reRunSummaryApi: true
    });

    if (originDeptId) {
      this.navigateWithoutLeavePrompt(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          originRoute,
          'department',
          originDeptId,
          'application',
          originId
        ],
        { queryParams: cleanQueryParams }
      );
    } else {
      this.navigateWithoutLeavePrompt(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          originRoute,
          'workflow-application',
          originId
        ],
        { queryParams: cleanQueryParams }
      );
    }
    return true;
  }
  private handleApplicantNavigation(): void {
    if (this.tryReturnToLinkedApplicationOrigin()) {
      return;
    }
    this.myApplicationsService.selectedApplicationId = null;

    this.myApplicationsService.triggerRefresh();

    const urlSegments = this._router.url.split('/');

    const isApplicationRoute = urlSegments.includes(
      applicantHomeRoutesNames.application.route
    );

    const lastRoute = isApplicationRoute
      ? applicantHomeRoutesNames.applyForPermit.route
      : applicantHomeRoutesNames.myApplications.route;

    this.scrollService.enableRestore();

    const deptIndex = urlSegments.indexOf('department');
    const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;
    const contractorRoute = urlSegments.includes(
      applicantHomeRoutesNames.myContractorRegistrations.route
    );
    if (isApplicationRoute && deptId) {
      this.navigateWithoutLeavePrompt(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          lastRoute,
          'department',
          deptId
        ],
        {
          queryParamsHandling: 'preserve'
        }
      );
    } else if (contractorRoute) {
      this.navigateWithoutLeavePrompt(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          applicantHomeRoutesNames.myContractorRegistrations.route
        ],
        {
          queryParamsHandling: 'preserve'
        }
      );
    } else {
      this.navigateWithoutLeavePrompt(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          lastRoute
        ],
        {
          queryParams: {
            s: null,
            skipActivityNavigation: null

          },
          queryParamsHandling: 'merge'
        }
      );
    }

    setTimeout(() => {
      this.enableSummaryInteractions();
    }, 0);
  }
  private handleDefaultNavigationOfApplicant(): void {
    if (this.tryReturnToLinkedApplicationOrigin()) {
      return;
    }
    const urlSegments = this._router.url.split('/');

    const isMyApplicationsRoute = this._router.url
      .split('/')
      .includes('my-applications');

    const isApplyForPermitRoute = urlSegments.includes(
      applicantHomeRoutesNames.applyForPermit.route
    );
    const contractorRoute = urlSegments.includes(
      applicantHomeRoutesNames.myContractorRegistrations.route
    );

    if (isMyApplicationsRoute || isApplyForPermitRoute) {
      this._router
        .navigate(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            applicantHomeRoutesNames.myApplications.route
          ],
          {
            queryParams: {
              s: null,
              skipActivityNavigation: null
            },
            queryParamsHandling: 'merge'
          }
        )
        .then(() => {
          this.myApplicationsService.triggerRefresh();
        });
      setTimeout(() => {
        this.enableSummaryInteractions();
      }, 0);
    } else if (contractorRoute) {
      this.navigateWithoutLeavePrompt(
        [
          '/jurisdiction',
          this.context.client.id,
          applicantHomeRoutesNames.root,
          applicantHomeRoutesNames.myContractorRegistrations.route
        ],
        {
          queryParamsHandling: 'preserve'
        }
      );
    } else {
      this.navigateToReferrer();
    }
  }

  private handleChildWorkflowNavigationOfApplicant(): void {
    if (this.tryReturnToLinkedApplicationOrigin()) {
      return;
    }
    const startingActivityId = 1;

    if (
      !this.callWorkflowsParentApplicationList ||
      this.callWorkflowsParentApplicationList.length === 0
    ) {
      return;
    }

    const isLastParentApplication =
      this.callWorkflowsParentApplicationList.length === 1;

    if (isLastParentApplication) {
      this.context.isJanusChildWorkflowCalled$.emit(false);
    }

    const appId = isLastParentApplication
      ? this.callWorkflowsParentApplicationList[0].applicationId
      : this.callWorkflowsParentApplicationList[
          this.callWorkflowsParentApplicationList.length - 1
        ].applicationId;

    const urlSegments = this._router.url.split('/');

    const isChildApplicationRoute = urlSegments.includes(
      applicantHomeRoutesNames.childApplication.route
    );

    const isApplyForPemitRoute = urlSegments.includes(
      applicantHomeRoutesNames.applyForPermit.route
    );
    const lastRoute =
      isChildApplicationRoute && isApplyForPemitRoute
        ? applicantHomeRoutesNames.applyForPermit.route
        : applicantHomeRoutesNames.myApplications.route;

    const deptIndex = urlSegments.indexOf('department');
    const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;
    const navigate = () => {
      if (isChildApplicationRoute && deptId) {
        this._router.navigate(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            lastRoute,
            'department',
            deptId,
            'application',
            appId
          ],
          {
            queryParamsHandling: 'preserve',
            state: {
              startingActivityId,
              useNewLayout: this.context?.useNewLayout || false
            }
          }
        );
      } else {
        this._router.navigate(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            lastRoute,
            'workflow-application',
            appId
          ],
          {
            queryParamsHandling: 'preserve',

            state: {
              startingActivityId,
              useNewLayout: this.context?.useNewLayout || false
            }
          }
        );
      }
    };

    if (isLastParentApplication) {
      this.callWorkflowsParentApplicationList = [];
      setTimeout(navigate, 500);
    } else {
      navigate();

      this.callWorkflowsParentApplicationList = this.callWorkflowsParentApplicationList.filter(
        ni => ni.applicationId !== appId
      );
    }
  }

  saveNotes() {
    const internalNotes: string = this.application.internalNotes;
    const externalNotes: string = this.application.externalNotes;

    this._workflowSvc
      .saveWorkflowApplicationNotes(
        this.applicationId,
        internalNotes,
        externalNotes
      )
      .subscribe(() => {
        this.toastr.success('Application Notes Saved');
      });
  }

  navigateToReferrer() {
    let returnURL = this.returnURL || this.context.applicationReturnURL || '';
    const params = {};
    try {
      const url: URL = new URL(`${location.origin}${returnURL}`);
      const sp: URLSearchParams = url.searchParams;
      sp.forEach((value, key) => {
        params[key] = value;
      });
      returnURL = url.pathname;
    } catch (err) { }

    if (
      returnURL !== '' &&
      returnURL.indexOf('/application/workflow-application/') === -1
    ) {
      this.navigateWithoutLeavePrompt([returnURL], { queryParams: params });
    } else {
      this.navigateWithoutLeavePrompt([
        '/jurisdiction',
        this.context.client.id
      ]);
    }
  }

  previous() {
    this.persistChildComponent().then(value => {
      this.disableButtons();
      this.processing = true;
      this.appInput.goPrevious(this.activity);
      // scroll to expanded row in data table
      this.workflowApplicationsJanusSvc.setData({
        ...this.workflowApplicationsJanusSvc.getData(),
        scrollToExpandedRow: true
      });
    });
  }

  exitTestApplication() {
    this.loadingExit = true;
    this._workflowSvc
      .cleanupTestApplication(this.context.applicationId)
      .subscribe(
        a => {
          this.context.applicationId$.emit(null);
          if (this.roleSubscription) {
            this.roleSubscription.unsubscribe();
            this.roleSubscription = null;
          }
          this.context.viewAsRole$.emit(null);
          this.context.testAsData$.emit(null);

          this.loadingExit = false;
          this.navigateToReferrer();
        },
        err => {
          this.loadingExit = false;
          this._errorHandler.handleError(err);
        }
      );

    return false;
  }

  cancel() {
    this.loadingDiscard = true;
    this.disableButtons();

    this._workflowSvc
      .cancelApplications(this.context.applicationId)
      .subscribe(o => {
        this.refreshUser();
        this.loadingDiscard = false;
        if (o) {
          this.navigateWithoutLeavePrompt([
            '/jurisdiction',
            this.context.client.id
          ]);
        }
      });
  }

  closeWorkflowApplication() {
    this.disableButtons();

    const closeReason: string = this.closeWorkflowApplicationForm.get(
      'closeReason'
    ).value;
    const closeDateTime = this.closeWorkflowApplicationForm.get('closeDateTime')
      .value;
    const closedBy: string = this.context.user.id;

    const closeRequest = new CloseApplicationRequest({
      requestedStatus: this.requestedCloseStatus,
      reason: closeReason,
      dateTime: closeDateTime,
      user: closedBy
    });

    this._workflowSvc
      .closeWorkflowApplication(this.context.applicationId, closeRequest)
      .subscribe(o => {
        if (o) {
          if (this.context.janusLayout === 'staff') {
            if (this._router.url.includes('renewals')) {
              this.closeRenewalInline();
              this.toastr.success(
                `Application changed to ${ApplicationStatus[this.requestedCloseStatus]
                }.`
              );
              return;
            }
            // handle on void,expire,lock,withdraw click for workflow-applications
            if (this._router.url.includes('workflow-applications')) {
              this.toastr.success(
                `Application changed to ${ApplicationStatus[this.requestedCloseStatus]
                }.`
              );
              this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
              // this._route.data.subscribe(data => {
              //   this.context.applicationViewType$.emit('none');
              //   if (data.applicationView === 'inline') {
              //     // re-run api
              //     setTimeout(() => {
              //       this.workflowApplicationsJanusSvc.setData({
              //         ...this.workflowApplicationsJanusSvc.getData(),
              //         reRunJanusApplicationDataTable: true
              //       });
              //     }, 500);

              //     // stay on same page
              //     const currentPage = this._route.snapshot.queryParamMap.get(
              //       'p'
              //     );
              //     this.navigateWithoutLeavePrompt([], {
              //       relativeTo: this._route,
              //       queryParams: { p: currentPage },
              //       queryParamsHandling: 'replace'
              //     });

              //     return;
              //   }
              // });
            }
          } else {
            this.navigateToReferrer();
          }
        }
      });
  }
  isMobile() {
    this.isMobileDevice = window.innerWidth < 768;
  }
  // Added by Amisha on 2026-08-31.
  // Reason: limit collapsible footer behavior to Janus layouts at the existing stacked breakpoint.
  get isJanusMobileView(): boolean {
    return (
      window.innerWidth <= 394 &&
      (this.context?.janusLayout === 'staff' ||
        this.context?.janusLayout === 'applicant')
    );
  }
  // Added by Amisha on 2026-08-31.
  // Reason: expand or collapse secondary actions from the arrow embedded in Next/Submit.
  toggleMobileActions(event: MouseEvent): void {
    event.stopPropagation();
    this.mobileActionsOpen = !this.mobileActionsOpen;
  }
  isMobileSaveButton = false;
  isMobileNavigationSaveButton() {
    this.isMobileSaveButton =
      window.innerWidth >= 393 && window.innerWidth <= 600;
  }
  canVoidChanged(e: { canVoid: boolean; canDiscard: boolean }) {
    const canVoid = e.canVoid;
    const canEdit = !this.activity ? false : this.activity.canEdit;
    const canDiscard = e.canDiscard;

    this.shouldShowVoid = canVoid && canEdit;

    this.shouldShowCancel = !canVoid && canDiscard && canEdit;
  }

  canUseNextChanged(e) {
    this.canUseNext = e;
    this.activitySetNextState = true;
  }
  loadUsingTestClient() {
    if (this.context.testAsData) {
      this.loadApplication(this.context.testAsData.applicationId);
    }
  }
  loadApplication(applicationId: string) {
    // Added by Vipul on 14-01-2026
    if (!applicationId || this.isContractorViewDestroyed) {
      return;
    }
    //Added by priya on 01-09-2026
    // Skip automatic activity navigation when opening the application from Current Activity.

    const skipActivityNavigation =
      this.isSaving ||
      this._route.snapshot.queryParamMap.get(
        'skipActivityNavigation'
      ) === 'true';


    //end by priya on 01-09-2026

    // End by Vipul on 14-01-2026
    this.applicationId = applicationId;
    // Added by Vipul on 14-01-2026
    if (!this.appInput) {
      this.pendingApplicationId = applicationId;
      return;
    }
    // End by Vipul on 14-01-2026
    this.appInput.applicationId = this.applicationId;
    // Added by Vipul on 14-01-2026
    if (this.context) {
      setTimeout(() => {
        if (!this.isContractorViewDestroyed) {
          this.context.applicationId$.emit(this.applicationId);
        }
      });
    }
    // End by Vipul on 14-01-2026
    const loadCurrent = () => {
      if (this.isContractorViewDestroyed) return;
      this.appInput.loadCurrentActivity().pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(a => {
        if (!a) {
          this.toastr.error(
            'We were unable to find the workflow application you requested.'
          );
          return;
        }

        this.isTestApplication = a.isTestApplication;

        if (!a.isProcessing) {
          this.context?.client$.emit(a.client);
          this.navigationItems = a.navigationItems;

          if (this.activityDataId && !skipActivityNavigation) {
            if (this.context.janusLayout === 'applicant') {
              this.scrollToTop()
            }
            this.navigate(this.activityDataId);
          }

          this.isTestApplication = a.isTestApplication;
          this.submitterId = a.submitterId;
          this.workflowName = a.workflowName;
          this.applicationNumber = a.applicationNumber;
          this.clientApplicationNumber = a.clientApplicationNumber;
          if (this.isTestApplication) {
            this.workflowId = a.workflowId;
            this.versionId = a.workflowVersionId;

            if (this.context?.client == null) {
              const testAsData = this.context?.testAsData;

              if (
                !testAsData ||
                testAsData.applicationId !== this.applicationId
              ) {
                this.appInput.activity = null;
                this.context?.testAsData$.next(null);
                // Added by Vipul on 29-07-2026
                if (this.templateForPermitForm) {
                  this.openTestWorkflowModal$.next();
                } else {
                  this.testAsClientModal.reset();
                  this.testAsClientModal.open();
                }
                // End by Vipul on 29-07-2026
              }
            }

            this._workflowSvc
              .getWorkflowRoles(a.workflowId)
              .pipe(takeUntil(this.contractorViewDestroyed$))
              .subscribe(roles => {
                this.testRoles = roles || [];

                if (
                  !this.testRoles.find(
                    r =>
                      r.id.toLowerCase() ===
                      SecurityService.APPLICANT_ROLE.id.toLowerCase()
                  )
                ) {
                  this.testRoles.unshift(SecurityService.APPLICANT_ROLE);
                }

                this.testRoles.forEach(r => (r.id = r.id.toLowerCase()));

                this.selectedRole = (
                  this.context?.viewAsRole?.id ||
                  a.activity?.model?.responsibleRoleId ||
                  SecurityService.APPLICANT_ROLE.id
                ).toLowerCase();

                this.roleSubscription?.unsubscribe();

                this.changeRole(this.selectedRole);

                this.roleSubscription = this.context?.viewAsRole$?.subscribe(
                  value => {
                    if (value != null) {
                      this.appInput.loadCurrentActivity().pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(ap => {
                        if (ap) {
                          this.isTestApplication = ap.isTestApplication;
                          this.navigationItems = ap.navigationItems;
                          this.fees = ap.fees;
                          this.hasFees = ap.hasFees;
                        }
                      });
                    }
                  }
                );
              });
          }

          // Contractor button state is already set by loadActivity -> changeActivity.
          // Do not overwrite the workflow's permissions and visibility flags.
          if (!this.isJanusContractorRegistration) {
            this.shouldShowNext = true;
            this.shouldShowPrevious = true;
            this.canUseCancelDiscard = true;
            this.shouldShowSave = true;

            if (!this.activitySetNextState) {
              this.canUseNext = true;
            }

            this.canUseSave = !(this.isPreview || this.isTestApplication);
          }
        } else {
          setTimeout(loadCurrent, 1000);

          this.shouldShowNext = false;
          this.shouldShowPrevious = false;
          this.canUseNext = false;
          this.canUseCancelDiscard = false;
          this.canUseSave = false;
        }
        if (
          this.context?.useNewLayout === true &&
          this.context?.isJanusChildWorkflowCalled === true
        ) {
          this.callWorkflowsParentApplicationList = this.navigationItems.filter(
            ni => ni?.applicationId
          );
          this.navigationItems = this.navigationItems.filter(
            ni => !ni?.applicationId
          );
        }
      });

    };
    loadCurrent();
  }
  updateRoute() {
    this.isMyApplicationsRoute = this._router.url.includes('my-applications');
  }
  isPrintSummaryOpen: boolean = false;
  ngOnInit() {
    this.isContractorRegistrationView = this.isJanusContractorRegistration;
    this.context.parentApplicationId$.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(id => {
      if (id) {
        const startingActivityId = '1';
        const appId = id;
        const result = this.updateParentWorkflowsList(appId);
        if (result === null) {
          return;
        }
        // Added by Amisha on 2026-07-24.
        // Reason: switch between Renewals parent and child workflows in place while preserving the inline expansion.
        if (
          this.context.janusLayout === 'staff' &&
          this._router.url.includes('renewals')
        ) {
          this.navigateWithoutLeavePrompt([], {
            relativeTo: this._route,
            queryParams: {
              isChild: result === true ? null : 1,
              cid: result === true ? null : appId,
              showAppView: 1
            },
            queryParamsHandling: 'merge'
          });
          return;
        }
        if (result === true) {
          if (this.context.janusLayout === 'staff') {
            if (this._router.url.includes('workflow-applications')) {
              // overlay
              if (this.context.applicationViewType === 'overlay') {
                setTimeout(() => {
                  this._router.navigate(
                    [
                      'admin',
                      'jurisdiction',
                      this.context.client.id,
                      'department',
                      this.context.staffDepartmentId,
                      'workflow-applications',
                      'data',
                      'application',
                      appId
                    ],
                    {
                      state: {
                        startingActivityId,
                        useNewLayout: this.context?.useNewLayout || false
                      }
                    }
                  );
                }, 500);
              } else if (this.context.applicationViewType === 'inline') {
                this.workflowApplicationsJanusSvc.setData({
                  ...this.workflowApplicationsJanusSvc.getData(),
                  reRunJanusApplicationDataTable: true
                });
                const currentId = this._route.snapshot.queryParamMap.get('id');
                const currentPage = this._route.snapshot.queryParamMap.get('p');
                const source = this._route.snapshot.queryParamMap.get('s');
                this._router.navigate(
                  [
                    'admin',
                    'jurisdiction',
                    this.context.client.id,
                    'department',
                    this.context.staffDepartmentId,
                    'workflow-applications',
                    'data'
                  ],
                  {
                    queryParams: {
                      p: currentPage,
                      s: source
                    },
                    queryParamsHandling: 'replace'
                  }
                );
                setTimeout(() => {
                  this._router.navigate(
                    [
                      'admin',
                      'jurisdiction',
                      this.context.client.id,
                      'department',
                      this.context.staffDepartmentId,
                      'workflow-applications',
                      'data'
                    ],
                    {
                      queryParams: {
                        id: currentId,
                        p: currentPage,
                        s: source
                      },
                      queryParamsHandling: 'replace'
                    }
                  );
                }, 1000);
              }
            }
          } else if (this.context.janusLayout === 'applicant') {
            this.handleDefaultNavigationOfApplicant();
          }
        } else {
          if (this.context.janusLayout === 'staff') {
            if (this._router.url.includes('workflow-applications')) {
              if (this.context.applicationViewType === 'overlay') {
                setTimeout(() => {
                  this._router.navigate(
                    [
                      'admin',
                      'jurisdiction',
                      this.context.client.id,
                      'department',
                      this.context.staffDepartmentId,
                      'workflow-applications',
                      'data',
                      'child-application',
                      appId
                    ],
                    {
                      state: {
                        startingActivityId,
                        useNewLayout: this.context?.useNewLayout || false
                      }
                    }
                  );
                }, 500);
              } else if (this.context.applicationViewType === 'inline') {
                this.workflowApplicationsJanusSvc.setData({
                  ...this.workflowApplicationsJanusSvc.getData(),
                  reRunJanusApplicationDataTable: true
                });
                const currentId = this._route.snapshot.queryParamMap.get('id');
                const currentPage = this._route.snapshot.queryParamMap.get('p');
                const source = this._route.snapshot.queryParamMap.get('s');
                this._router.navigate(
                  [
                    'admin',
                    'jurisdiction',
                    this.context.client.id,
                    'department',
                    this.context.staffDepartmentId,
                    'workflow-applications',
                    'data'
                  ],
                  {
                    queryParams: {
                      id: currentId,
                      p: currentPage,
                      isChild: 1,
                      cid: appId,
                      s: source
                    },
                    queryParamsHandling: 'replace'
                  }
                );
              }
            }
          } else if (this.context.janusLayout === 'applicant') {
            const startingActivityId = '1';

            const urlSegments = this._router.url.split('/');

            const isApplicationRoute = urlSegments.includes(
              applicantHomeRoutesNames.application.route
            );

            const lastRoute = isApplicationRoute
              ? applicantHomeRoutesNames.applyForPermit.route
              : applicantHomeRoutesNames.myApplications.route;

            const deptIndex = urlSegments.indexOf('department');
            const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;

            if (isApplicationRoute && deptId) {
              this._router.navigate(
                [
                  '/jurisdiction',
                  this.context.client.id,
                  applicantHomeRoutesNames.root,
                  lastRoute,
                  'department',
                  deptId,
                  'child-application',
                  id
                ],
                {
                  queryParamsHandling: 'preserve'
                }
              );
            } else {
              this._router.navigate(
                [
                  '/jurisdiction',
                  this.context.client.id,
                  applicantHomeRoutesNames.root,
                  lastRoute,
                  'child-application',
                  id
                ],
                {
                  state: {
                    startingActivityId,
                    useNewLayout: this.context?.useNewLayout || false
                  }
                }
              );
            }
          }
        }
        this.context.parentApplicationId$.emit(null);
      }
    });
    if (this.isJanusAppViewFlow()) {
      history.pushState(null, '', location.href); // Code added by Sanchit on 12/06/2026
    }
    if (this.context.janusLayout === 'staff') {
      // Added by Vipul on 29-07-2026
      this.openTestWorkflowModal$.pipe(take(1)).subscribe(() => {
        this.showTestWorkflowModal = true;
      });
      // End by Vipul on 29-07-2026

      if (this._router.url.includes('workflow-applications')) {
        this._route.data.subscribe(data => {
          if (data.applicationView === 'inline') {
            this.showCloseIcon = false;
          }
        });
      }
      //Added by amisha on 04/14/2026
      // Keep the inline renewal stepper aligned with workflow-applications:
      // when renewals opens wm-app inside the Janus inline panel, it sets
      // showAppView=1, so we hide the app-view close icon in that embedded mode.
      if (this._router.url.includes('renewals')) {
        this._route.queryParamMap.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(params => {
          this.showCloseIcon = params.get('showAppView') !== '1';
        });
      }

      if (this._router.url.includes('contractors')) {
        this._route.queryParamMap.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(params => {
          this.showCloseIcon = params.get('showAppView') !== '1';
        });
      }
    }

    // added by priya 26-12-2025

    this._router.events.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(() => {
      this.updateRouteFlags();
      this.updateRoute();
    });

    //end by priya 26-12-2026

    this.isMobile();
    this.isMobileNavigationSaveButton();
    this.processing = true;
    const previousURL = this._previousRouteSvc.getPreviousUrl() || '';
    this._route.queryParams.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(parms => {
      this.returnURL = parms['returnURL'];
      // Start Code added by Sanchit on 07/15/2026
      this.isTestContractorWorkflow =
        parms['isTestContractorWorkflow'] === 'true';
      // End Code added by Sanchit on 07/15/2026
    });

    this.appIdSubscription = this.context.applicationId$.subscribe(appId => {
      setTimeout(() => {
        if (this.isContractorViewDestroyed) return;
        this.applicationId = appId;
        if (this.appInput) {
          this.appInput.applicationId = appId;
        }
      }, 500);
    });

    this._securitySvc
      .isLoginEntitled(Actions.VIEW_APPLICATION_VERSION)
      .subscribe(result => {
        this.canViewVersion = result;
      });
    this._securitySvc
      .isLoginEntitled(Actions.EDIT_APPLICATION_NUMBER)
      .subscribe(result => {
        this.canEditApplicationNumber = result;
      });

    this._route.params.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(params => {
      if (!params['applicationId']) return;
      this.workflowId = params['workflowId'];
      this.isTestApplication = params['isTest'];
      this.activityDataId = params['activityDataId'];

      // determine the previous URL
      this._route.url.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(value => {
        const currentURL = '/' + value.join('/');

        if (currentURL !== (previousURL || '')) {
          this.context.applicationReturnURL$.emit(previousURL);
        }
      });

      this.applicationId = params['applicationId'];
      this.loadApplication(params['applicationId']);
    });

    this.queryParamMapSubscription = this._route.queryParamMap.pipe(takeUntil(this.contractorViewDestroyed$)).subscribe(
      params => {
        if (!params.get('id')) return;
        this.context.applicationViewType$.emit('inline');
        const isChild = params.get('isChild');
        const isLinkedApp = params.get('isLinkedApp');
        if (isChild === '1' || isLinkedApp === '1') {
          this.loadApplication(params.get('cid'));
        } else {
          this.activityDataId = params.get('activityDataId');
          this.isTestApplication = params.get('isTest') === 'true';
          this.workflowId = params.get('workflowId');
          this.loadApplication(params.get('id'));
        }
      }
    );

    this.loading = true;

    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }
  skeletonArray = Array(6).fill(0);

  changeButtonAvailability(e: boolean) {
    this.applicationProcessing = e;
  }
  onJanusParentWorkflowApplicationClick = (id: string) => {
    const result = this.updateParentWorkflowsList(id);
    if (result === null) {
      return;
    }
    if (result === true) {
      const startingActivityId = '1';
      if (this.context.janusLayout === 'staff') {
        if (this._router.url.includes('workflow-applications')) {
          if (this.context.applicationViewType === 'overlay') {
            setTimeout(() => {
              this._router.navigate(
                [
                  'admin',
                  'jurisdiction',
                  this.context.client.id,
                  'department',
                  this.context.staffDepartmentId,
                  'workflow-applications',
                  'data',
                  'application',
                  id
                ],
                {
                  state: {
                    startingActivityId,
                    useNewLayout: this.context?.useNewLayout || false
                  }
                }
              );
            }, 100);
          } else if (this.context.applicationViewType === 'inline') {
            const currentId = this._route.snapshot.queryParamMap.get('id');
            const currentPage = this._route.snapshot.queryParamMap.get('p');
            const source = this._route.snapshot.queryParamMap.get('s');
            this._router.navigate([], {
              relativeTo: this._route,
              queryParams: {
                p: currentPage,
                s: source
              },
              queryParamsHandling: 'replace'
            });
            setTimeout(() => {
              this._router.navigate([], {
                relativeTo: this._route,
                queryParams: {
                  id: currentId,
                  p: currentPage,
                  s: source
                },
                queryParamsHandling: 'replace'
              });
            }, 500);
          }
        }
      } else if (this.context.janusLayout === 'applicant') {
        this.handleDefaultNavigationOfApplicant();
      }
    } else {
      const startingActivityId = '1';
      if (this.context.janusLayout === 'staff') {
        if (this._router.url.includes('workflow-applications')) {
          if (this.context.applicationViewType === 'overlay') {
            // overlay
            setTimeout(() => {
              this._router.navigate(
                [
                  'admin',
                  'jurisdiction',
                  this.context.client.id,
                  'department',
                  this.context.staffDepartmentId,
                  'workflow-applications',
                  'data',
                  'child-application',
                  id
                ],
                {
                  state: {
                    startingActivityId,
                    useNewLayout: this.context?.useNewLayout || false
                  }
                }
              );
            }, 500);
          } else if (this.context.applicationViewType === 'inline') {
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            const currentId = this._route.snapshot.queryParamMap.get('id');
            const currentPage = this._route.snapshot.queryParamMap.get('p');
            const source = this._route.snapshot.queryParamMap.get('s');
            this._router.navigate(
              [
                'admin',
                'jurisdiction',
                this.context.client.id,
                'department',
                this.context.staffDepartmentId,
                'workflow-applications',
                'data'
              ],
              {
                queryParams: {
                  id: currentId,
                  p: currentPage,
                  isChild: 1,
                  cid: id,
                  showAppView: 1,
                  s: source
                },
                queryParamsHandling: 'replace'
              }
            );
          }
        }
      } else if (this.context.janusLayout === 'applicant') {
        const startingActivityId = '1';

        const urlSegments = this._router.url.split('/');

        const isApplicationRoute = urlSegments.includes(
          applicantHomeRoutesNames.application.route
        );

        const lastRoute = isApplicationRoute
          ? applicantHomeRoutesNames.applyForPermit.route
          : applicantHomeRoutesNames.myApplications.route;

        const deptIndex = urlSegments.indexOf('department');
        const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;

        if (isApplicationRoute && deptId) {
          this._router.navigate(
            [
              '/jurisdiction',
              this.context.client.id,
              applicantHomeRoutesNames.root,
              lastRoute,
              'department',
              deptId,
              'child-application',
              id
            ],
            {
              queryParamsHandling: 'preserve'
            }
          );
        } else {
          this._router.navigate(
            [
              '/jurisdiction',
              this.context.client.id,
              applicantHomeRoutesNames.root,
              lastRoute,
              'child-application',
              id
            ],
            {
              state: {
                startingActivityId,
                useNewLayout: this.context?.useNewLayout || false
              }
            }
          );
        }
      }
    }
  };

  withdrawApplication() {
    this.requestedCloseStatus = ApplicationStatus.Withdrawn;

    this.closeApplicationText = 'Withdraw';

    this.openCloseApplicationModal();
  }

  lockApplication() {
    this.requestedCloseStatus = ApplicationStatus.Locked;

    this.closeApplicationText = 'Lock';

    this.openCloseApplicationModal();
  }

  expireApplication() {
    this.requestedCloseStatus = ApplicationStatus.Expired;

    this.closeApplicationText = 'Expire';

    this.openCloseApplicationModal();
  }

  voidApplication() {
    this.requestedCloseStatus = ApplicationStatus.Voided;

    this.closeApplicationText = 'Void';

    this.openCloseApplicationModal();
  }

  openCloseApplicationModal() {
    this.closeWorkflowApplicationForm.controls['closeDateTime'].setValue(
      this.pipe.transform(Date.now(), 'MM/dd/yyyy h:mm:ss a')
    );
    this.closeReason.reset();

    if (this.templateForPermitForm) {
      // janus layout uses wm-common-confirmation-modal driven by data.open
      this.openCloseApplicationModalForDropdown();
      return;
    }

    if (this.closeApplicationModal) {
      this.closeApplicationModal.open();
    }
  }
  get showLoader(): boolean {
    return !this.activity;
  }

  openRequiredDocumentsModal() {
    if (this.requiredDocumentsModal) {
      this.requiredDocumentsModal.open();
    }
  }

  @ViewChild('cancelModal', { static: false }) cancelModal: any;

  cancelModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to discard this application?',
    modalSubDescp: `Clicking "Discard" will delete the application permanently`,
    yesNoBtn: true,
    replaceYesWith: 'DISCARD',
    replaceNoWith: 'CANCEL'
  };

  openCancelModal = () => {
    this.cancelModalData = {
      ...this.cancelModalData,
      open: true
    };
    this.cd.detectChanges();
  };

  closeCancelModal = () => {
    this.cancelModalData = {
      ...this.cancelModalData,
      open: false
    };
    this.cd.detectChanges();
  };

  discardApplication = () => {
    this.cancelModalData = {
      ...this.cancelModalData,
      open: false
    };
    // Added by amisha on 27-02-2026 for handling discard click for renewal application in staff janus layout
    // Start discard loader and disable buttons
    this.loadingDiscard = true;
    this.disableButtons();

    // Call Cancel Application API
    this._workflowSvc.cancelApplications(this.context.applicationId).subscribe({
      next: o => {
        this.refreshUser();
        this.loadingDiscard = false;
        if (o) {
          if (this.context.janusLayout === 'staff') {
            // Added by amisha on 05-03-2026 for handling discard click for renewal application in staff janus layout
            if (this._router.url.includes('renewals')) {
              this.closeRenewalInline();
              return;
            }
            if (this._router.url.includes('/contractors/all/application/')) {
              this.returnToContractorRegistrations();
              return;
            }
            // handle on discard click for workflow-applications
            if (this._router.url.includes('workflow-applications')) {
              this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
            }
            if (this._router.url.includes('/contractors/all')) {
              this.closeContractorRenewalInline();
              return;
            }
          } else if (this.context.janusLayout === 'applicant') {
            this.myApplicationsService.selectedApplicationId = null;

            this.scrollService.enableRestore();

            this._route.data.subscribe(data => {
              if (data.type === 'child-application') {
                this.handleChildWorkflowNavigationOfApplicant();
              } else {
                this.handleApplicantNavigation();
              }
            });
          }
        } else {
          // handle case in case o undefined
        }
      },
      error: err => {
        // If API fails, stop loader and re-enable buttons
        this.loadingDiscard = false;
        this.reenableButtons();
        this._errorHandler.handleError(err);
      }
    });
  };

  // added by priya 08-01-2026
  @ViewChild('backModal', { static: false }) backModal: any;

  backModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to go back?',
    modalSubDescp:
      'Clicking "Back" will exit the application without saving your changes.',
    yesNoBtn: true,
    replaceYesWith: 'BACK',
    replaceNoWith: 'CANCEL'
  };

  openBackModal = () => {
    if (this.context?.isJanusChildWorkflowCalled === true) {
      this.backModalData = {
        ...this.backModalData,
        modalDescp: 'You are leaving a related application',
        modalSubDescp: 'You’ll be directed back to the original application',
        open: true
      };
    } else {
      this.backModalData = {
        ...this.backModalData,
        open: true
      };
    }

    this.cd.detectChanges();
  };
  onBackClick() {
    if (
      this.context?.isJanusChildWorkflowCalled === true &&
      this.activity.activityDataId === this.navigationItems[0].activityDataId
    ) {
      this.openBackModal();
      return;
    }
    //  Updated by priya on 08-09-2026
    // Use the activity's actual previous-navigation state instead of canUsePrevious,
    // as canUsePrevious can be temporarily disabled during processing
    // Back button clickable on the first activity to allow the confirmation modal to be displayed.
    if (!this.activity?.canGoPrevious) {
      // added by priya 01-04-2026
      if (this.context.janusLayout === 'applicant') {
        this.scrollToTop();
      }
      // end by priya 01-04-2026

      this.openBackModal();
      return;
    }

    this.previous();
    // added by priya 01-04-2026

    if (this.context.janusLayout === 'applicant') {
      this.scrollToTop();
    }
    // end by priya 01-04-2026
  }

  onCloseBackModal = () => {
    this.backModalData = {
      ...this.backModalData,
      open: false
    };
    this.cd.detectChanges();
  };
  backApplication = () => {
    this.backModalData = {
      ...this.backModalData,
      open: false
    };
    if (this.context.janusLayout === 'staff') {
      // Added by amisha on 05-03-2026 for handling back click for renewal application in staff janus layout
      if (this._router.url.includes('renewals')) {
        this.closeRenewalInline();
        return;
      }
      if (this._router.url.includes('/contractors/all/application/')) {
        this.returnToContractorRegistrations();
        return;
      }
      // Preserve the existing Contractor Types AppView navigation.
      if (this._router.url.includes('contractors')) {
        this.context.applicationViewType$.emit('none');
        this.context.applicationId$.emit(null);

        this.cd.detectChanges();

        this._router
          .navigate(['../../'], {
            relativeTo: this._route,
            queryParamsHandling: 'preserve'
          })
          .then(() => {
            this.navigateToReferrer();
          });

        return;
      }
      // handle on back click for workflow-applications
      if (this._router.url.includes('workflow-applications')) {
        this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
      }
    } else if (this.context.janusLayout === 'applicant') {
      this.myApplicationsService.selectedApplicationId = null;

      this.scrollService.enableRestore();

      this._route.data.subscribe(data => {
        if (data.type === 'child-application') {
          this.handleChildWorkflowNavigationOfApplicant();
        } else {
          this.handleApplicantNavigation();
        }
      });
    }
  };

  // end by priya 08-01-2026

  // added by priya 07-01-2026
  isMyApplicationsRoute = false;
  private updateRouteFlags(): void {
    const urlSegments = this._router.url.split('/');

    this.isMyApplicationsRoute = urlSegments.includes(
      applicantHomeRoutesNames.myApplications.route
    );
  }

  @ViewChild('closeModal', { static: false }) closeModal: any;

  closeModalData: CommonConfirmationModalData = {
    modalDescp: 'Are you sure you want to close this application?',
    modalSubDescp: `Clicking "Close" will exit the application without saving`,
    yesNoBtn: true,
    replaceYesWith: 'CLOSE',
    replaceNoWith: 'CANCEL',
    open: false
  };

  openModal = () => {
    if (this.context?.isJanusChildWorkflowCalled === true) {
      this.closeModalData = {
        ...this.closeModalData,
        modalDescp: 'You are leaving a related application',
        modalSubDescp: `You’ll be directed back to the original application`,
        open: true
      };
    } else {
      this.closeModalData = {
        ...this.closeModalData,
        open: true
      };
    }

    this.cd.detectChanges();
  };

  handleJanusWorkflowApplicationsRoutingOnAppViewEvents = () => {
    this._route.data.subscribe(data => {
      this.context.applicationViewType$.emit('none');
      if (data.applicationView === 'overlay') {
        if (data.type === 'child-application') {
          const goToParentId =
            this.callWorkflowsParentApplicationList[
              this.callWorkflowsParentApplicationList.length - 1
            ].applicationId || null;
          if (goToParentId) {
            const startingActivityId = 1;
            const result = this.updateParentWorkflowsList(goToParentId);
            if (result === null) {
              return;
            }
            if (result === true) {
              setTimeout(() => {
                this._router.navigate(
                  [
                    'admin',
                    'jurisdiction',
                    this.context.client.id,
                    'department',
                    this.context.staffDepartmentId,
                    'workflow-applications',
                    'data',
                    'application',
                    goToParentId
                  ],
                  {
                    state: {
                      startingActivityId,
                      useNewLayout: this.context?.useNewLayout || false
                    }
                  }
                );
              }, 500);
            } else {
              setTimeout(() => {
                this._router.navigate(
                  [
                    'admin',
                    'jurisdiction',
                    this.context.client.id,
                    'department',
                    this.context.staffDepartmentId,
                    'workflow-applications',
                    'data',
                    'child-application',
                    goToParentId
                  ],
                  {
                    state: {
                      startingActivityId,
                      useNewLayout: this.context?.useNewLayout || false
                    }
                  }
                );
              }, 500);
            }
          }
        } else if (
          this.context.isLinkedApplicationLaunch &&
          this.context.linkedApplicationOriginId
        ) {
          // Not a real workflow parent/child - just an unrelated
          // application launched from another one (e.g. contractor
          // registration). Return to the application that launched it.
          const originId = this.context.linkedApplicationOriginId;
          this.context.isLinkedApplicationLaunch = false;
          this.context.linkedApplicationOriginId = null;

          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            reRunJanusApplicationDataTable: true
          });

          const startingActivityId = 1;
          this._router.navigate(
            [
              'admin',
              'jurisdiction',
              this.context.client.id,
              'department',
              this.context.staffDepartmentId,
              'workflow-applications',
              'data',
              'application',
              originId
            ],
            {
              state: {
                startingActivityId,
                useNewLayout: this.context?.useNewLayout || false
              }
            }
          );
        } else {
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            reRunJanusApplicationDataTable: true
          });

          this._router.navigate(['../../'], {
            relativeTo: this._route,
            queryParams: { p: 1 },
            queryParamsHandling: 'replace'
          });
        }
      } else if (data.applicationView === 'inline') {
        const isLinkedApp = this._route.snapshot.queryParamMap.get(
          'isLinkedApp'
        );
        if (isLinkedApp === '1') {
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            reRunJanusApplicationDataTable: true
          });
          const currentPage = this._route.snapshot.queryParamMap.get('p');
          const currentId = this._route.snapshot.queryParamMap.get('id');
          const source = this._route.snapshot.queryParamMap.get('s');
          this._router.navigate([], {
            relativeTo: this._route,
            queryParams: { p: currentPage, id: currentId, s: source },
            queryParamsHandling: 'replace'
          });
          return;
        }
        const isChildWorkflow = this._route.snapshot.queryParamMap.get(
          'isChild'
        );
        if (isChildWorkflow === '1') {
          const goToParentId =
            this.callWorkflowsParentApplicationList[
              this.callWorkflowsParentApplicationList.length - 1
            ].applicationId || null;
          const result = this.updateParentWorkflowsList(goToParentId);
          if (result === null) {
            return;
          }
          if (result === true) {
            const currentPage = this._route.snapshot.queryParamMap.get('p');
            const currentId = this._route.snapshot.queryParamMap.get('id');
            const source = this._route.snapshot.queryParamMap.get('s');
            this._router.navigate([], {
              relativeTo: this._route,
              queryParams: { p: currentPage, s: source },
              queryParamsHandling: 'replace'
            });
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                reRunJanusApplicationDataTable: true
              });
              setTimeout(() => {
                this._router.navigate([], {
                  relativeTo: this._route,
                  queryParams: { p: currentPage, id: currentId, s: source },
                  queryParamsHandling: 'replace'
                });
              }, 500);
            }, 500);
          } else {
            const currentPage = this._route.snapshot.queryParamMap.get('p');
            const currentId = this._route.snapshot.queryParamMap.get('id');
            const source = this._route.snapshot.queryParamMap.get('s');
            this._router.navigate([], {
              relativeTo: this._route,
              queryParams: {
                p: currentPage,
                s: source
              },
              queryParamsHandling: 'replace'
            });
            setTimeout(() => {
              this.workflowApplicationsJanusSvc.setData({
                ...this.workflowApplicationsJanusSvc.getData(),
                reRunJanusApplicationDataTable: true
              });
              this._router.navigate([], {
                relativeTo: this._route,
                queryParams: {
                  p: currentPage,
                  id: currentId,
                  isChild: 1,
                  cid: goToParentId,
                  s: source
                },
                queryParamsHandling: 'replace'
              });
            }, 500);
          }
        } else {
          const currentPage = this._route.snapshot.queryParamMap.get('p');
          const source = this._route.snapshot.queryParamMap.get('s');
          this._router.navigate([], {
            relativeTo: this._route,
            queryParams: { p: currentPage, s: source },
            queryParamsHandling: 'replace'
          });
          setTimeout(() => {
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
          }, 500);
        }
      }
    });
  };

  onCloseModal = () => {
    this.closeModalData = {
      ...this.closeModalData,
      open: false
    };
    this.cd.detectChanges();
  };
  closeApplication = () => {
    this.closeModalData = {
      ...this.closeModalData,
      open: false
    };
    if (this.context.janusLayout === 'staff') {
      //Added by amisha on 23-02-2026 for handling close click for renewal application in staff janus layout
      if (this._router.url.includes('renewals')) {
        this.closeRenewalInline();
        return;
      }
      if (this._router.url.includes('/contractors/all/application/')) {
        this.returnToContractorRegistrations();
        return;
      }
      // Preserve the existing Contractor Types AppView navigation.
      if (this._router.url.includes('contractors')) {
        this.context.applicationViewType$.emit('none');
        this.context.applicationId$.emit(null);

        this.cd.detectChanges();

        this._router
          .navigate(['../../'], {
            relativeTo: this._route,
            queryParamsHandling: 'preserve'
          })
          .then(() => {
            this.navigateToReferrer();
          });

        return;
      }

      // handle on close click for workflow-applications
      if (this._router.url.includes('workflow-applications')) {
        this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
      }
    } else if (this.context.janusLayout === 'applicant') {
      this.myApplicationsService.selectedApplicationId = null;

      this._route.data.subscribe(data => {
        if (data.type === 'child-application') {
          this.handleChildWorkflowNavigationOfApplicant();
        } else {
          this.handleApplicantNavigation();
        }
      });
    }
  };

  private enableSummaryInteractions(): void {
    const cards = document.querySelectorAll('.hover-summary-card');
    cards.forEach((el: any) => {
      el.style.pointerEvents = 'auto';
      el.style.cursor = 'pointer';
    });

    const footers = document.querySelectorAll(
      '.alert-summary-footer wm-common-button'
    );
    footers.forEach((el: any) => {
      el.style.setProperty('--button-font-color', '#2196F3', 'important');
      el.style.pointerEvents = 'auto';
      el.style.cursor = 'pointer';
    });
  }
  // end by priya 07-01-2026
  @ViewChild('saveAndExitModal', { static: false }) saveAndExitModal: any;

  saveAndExitModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to save and exit this application?',
    modalSubDescp:
      this.context.janusLayout === 'applicant'
        ? `You can find your saved application in My Applications and pick up where you left off`
        : `You can find your saved application in Applications and pick up where you left off`,
    // modalSubDescp: `You can find your saved application in My Applications and pick up where you left off`,
    yesNoBtn: true,
    replaceYesWith: 'SAVE & EXIT',
    replaceNoWith: 'CANCEL'
  };

  saveAndExitOpenModal = () => {
    if (this.context?.isJanusChildWorkflowCalled === true) {
      this.saveAndExitModalData = {
        ...this.saveAndExitModalData,
        modalDescp: 'You are leaving a related application',
        modalSubDescp: 'You’ll be directed back to the original application',
        open: true
      };
    } else {
      this.saveAndExitModalData = {
        ...this.saveAndExitModalData,
        open: true
      };
    }

    this.cd.detectChanges();
  };

  saveAndExitcloseModal = () => {
    this.saveAndExitModalData = {
      ...this.saveAndExitModalData,
      open: false
    };
    this.cd.detectChanges();
  };
  handleSaveAndExit() {
    this.saveAndExitcloseModal();
    this.save(true);
  }

  //end by priya 2025-11-12
  //added by priya 25-02-2026

  @ViewChild('exitModal', { static: false }) exitModal: any;
  exitModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to exit this application?',
    modalSubDescp: `Any unsaved changes will be lost`,
    yesNoBtn: true,
    replaceYesWith: 'EXIT',
    replaceNoWith: 'CANCEL'
  };

  // Added by Amisha on 2026-06-12.
  // Reason: dedicated Janus route-leave messaging for shell/sidebar/navbar exits.
  routeLeaveModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to leave this application?',
    modalSubDescp: 'Any unsaved changes will be lost.',
    yesNoBtn: true,
    replaceYesWith: 'LEAVE',
    replaceNoWith: 'CANCEL'
  };

  // Added by Amisha on 2026-06-12.
  // Reason: dedicated Janus stepper confirmation when the user jumps directly to another step.
  stepNavigationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to leave this step?',
    modalSubDescp: 'Any unsaved changes will be lost.',
    yesNoBtn: true,
    replaceYesWith: 'LEAVE',
    replaceNoWith: 'CANCEL'
  };

  exitOpenModal = () => {
    if (this.context?.isJanusChildWorkflowCalled === true) {
      this.exitModalData = {
        ...this.exitModalData,
        modalDescp: 'You are leaving a related application',
        modalSubDescp: 'You’ll be directed back to the original application',
        open: true
      };
    } else {
      this.exitModalData = {
        ...this.exitModalData,
        open: true
      };
    }

    this.cd.detectChanges();
  };

  exitcloseModal = () => {
    this.exitModalData = {
      ...this.exitModalData,
      open: false
    };
    this.cd.detectChanges();
  };
  handleExit() {
    // Start Code added by Sanchit on 07/15/2026
    if (this.isTestContractorWorkflow) {
      if (this._router.url.includes('/contractors/all/application/')) {
        this.exitcloseModal();
        this.returnToContractorRegistrations();
        return;
      }

      this.context.applicationViewType$.emit('none');

      this._router.navigate(['../../'], {
        relativeTo: this._route
      });

      return;
    }
    // End Code added by Sanchit on 07/15/2026
    this.exitcloseModal();
    if (this.context.janusLayout === 'staff') {
      if (this._router.url.includes('/contractors/all/application/')) {
        this.returnToContractorRegistrations();
        return;
      }
      if (this.isJanusContractorRegistration) {
        this.closeContractorRenewalInline();
        return;
      }
      // Preserve the existing Contractor Types AppView navigation.
      if (this._router.url.includes('contractors')) {
        this.context.applicationViewType$.emit('none');
        this.context.applicationId$.emit(null);
        this.navigateToReferrer();
        return;
      }
      if (this._router.url.includes('workflow-applications')) {
        this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
      }
    } else if (this.context.janusLayout === 'applicant') {
      if (this.tryReturnToLinkedApplicationOrigin()) {
        // NEW — mirrors handleSaveAndExit/submitConfirm
        return;
      }
      const url = this._router.url;

      const currentRoute = url.includes(
        applicantHomeRoutesNames.applyForPermit.route
      );
      const urlSegments = this._router.url.split('/');

      const deptIndex = urlSegments.indexOf('department');
      const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;

      if (currentRoute) {
        this.navigateWithoutLeavePrompt(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            applicantHomeRoutesNames.applyForPermit.route,
            'department',
            deptId
          ],
          {
            queryParamsHandling: 'preserve'
          }
        );
      } else {
        this.navigateWithoutLeavePrompt(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            applicantHomeRoutesNames.myApplications.route
          ],
          {
            queryParamsHandling: 'preserve'
          }
        );
      }
    }
  }
  confirmationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: true,
    replaceYesWith: '',
    replaceNoWith: 'Cancel',
    modalWidth: '620px' // Code added by Sanchit on 18/05/2026
  };
  openCloseApplicationModalForDropdown() {
    this.confirmationModalData = {
      ...this.confirmationModalData,
      open: true,
      modalDescp: `${this.closeApplicationText} Application`,
      modalSubDescp: `Are you sure you want to ${this.closeApplicationText.toLowerCase()} this application?`,
      replaceYesWith: this.closeApplicationText
    };

    this.cd.detectChanges();
  }

  @ViewChild('saveModal', { static: false }) saveModal: any;
  saveModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to save this application?',
    modalSubDescp: `Your changes will be saved and you can continue working on this application later.`,
    yesNoBtn: true,
    replaceYesWith: 'SAVE',
    replaceNoWith: 'CANCEL'
  };
  isApplicantMobileView: boolean = false;
  saveOpenModal = () => {
    this.saveModalData = {
      ...this.saveModalData,
      open: true
    };
    this.cd.detectChanges();
  };

  saveCloseModal = () => {
    this.saveModalData = {
      ...this.saveModalData,
      open: false
    };
    this.cd.detectChanges();
  };

  saveConfirm() {
    this.saveCloseModal();
    this.save(false);
  }

  @ViewChild('submitModal', { static: false }) submitModal: any;
  submitModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to submit this application?',
    modalSubDescp: `Once submitted, you will not be able to make further changes. Please review all information before submitting.`,
    yesNoBtn: true,
    replaceYesWith: 'SUBMIT',
    replaceNoWith: 'CANCEL'
  };

  submitOpenModal = () => {
    if (this.context?.isJanusChildWorkflowCalled === true) {
      this.submitModalData = {
        ...this.submitModalData,
        modalDescp: 'You are leaving a related application',
        modalSubDescp: 'You’ll be directed back to the original application',
        open: true
      };
    } else {
      this.submitModalData = {
        ...this.submitModalData,
        open: true
      };
    }

    this.cd.detectChanges();
  };

  submitCloseModal = () => {
    this.submitModalData = {
      ...this.submitModalData,
      open: false
    };
    if (this.autoSubmitComplete) {
      this.autoSubmitComplete = false;
      this.reenableButtons();
      this.appInput.goPrevious(this.activity);
    }
    this.cd.detectChanges();
  };

  submitConfirm() {
    const wasAutoSubmit = this.autoSubmitComplete;
    // Confirming a contractor registration must not navigate to a completed step.
    if (this.isJanusContractorRegistration) {
      this.autoSubmitComplete = false;
    }
    this.submitCloseModal();

    if (wasAutoSubmit) {
      if (this.context.janusLayout === 'staff') {
        if (this._router.url.includes('renewals')) {
          this.closeRenewalInline();
          return;
        }
        if (this._router.url.includes('/contractors/all/application/')) {
          this.returnToContractorRegistrations();
          return;
        }
        if (this.isJanusContractorRegistration) {
          this.closeContractorRenewalInline();
          return;
        }
        if (this._router.url.includes('workflow-applications')) {
          this.handleJanusWorkflowApplicationsRoutingOnAppViewEvents();
        }
        if (this.isTestContractorWorkflow) {
          this.returnToContractorTypeEdit();
          return;
        }
      } else if (this.context.janusLayout === 'applicant') {
        if (this.tryReturnToLinkedApplicationOrigin()) {
          return;
        }
        const currentUrl = this._router.url;
        if (currentUrl.includes('applicant-home/application')) {
          this.navigateWithoutLeavePrompt([
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            applicantHomeRoutesNames.myApplications.route
          ]);
        } else {
          this.navigateWithoutLeavePrompt(
            [
              '/jurisdiction',
              this.context.client.id,
              applicantHomeRoutesNames.root,
              applicantHomeRoutesNames.myApplications.route
            ],
            { queryParamsHandling: 'preserve' }
          ).then(() => {
            this.myApplicationsService.triggerRefresh();
          });
        }
      }
      return;
    }

    this.handleSubmitClick();
  }

  // Added by Amisha on 2026-07-21.
  // Reason: close the contractor AppView overlay for every exit path and return
  // directly to Contractor Registrations instead of using the My Applications referrer.
  private returnToContractorRegistrations(): void {
    this.context.applicationViewType = 'none';
    this.context.applicationViewType$.emit('none');
    this.context.applicationId$.emit(null);

    this.navigateWithoutLeavePrompt([], {
      relativeTo: this._route.parent,
      queryParams: {},
      queryParamsHandling: 'replace'
    });
  }

  //end by priya 25-02-2026

  openApplicationSummary(): void {
    if (this.context.janusLayout === 'staff') {
      if (this._router.url.includes('workflow-applications')) {
        this._route.data.subscribe(data => {
          this.context.applicationViewType$.emit('none');
          if (data.applicationView === 'inline') {
            const currentPage = this._route.snapshot.queryParamMap.get('p');
            const currentId = this._route.snapshot.queryParamMap.get('id');
            this.navigateWithoutLeavePrompt([], {
              relativeTo: this._route,
              queryParams: { p: currentPage },
              queryParamsHandling: 'replace'
            });
            setTimeout(() => {
              this.navigateWithoutLeavePrompt([], {
                relativeTo: this._route,
                queryParams: {
                  p: currentPage,
                  id: currentId,
                  showAppView: 2
                },
                queryParamsHandling: 'replace'
              });
            }, 500);
          }
        });
      }
    } else if (this.context.janusLayout === 'applicant') {
      this.navigateWithoutLeavePrompt(
        ['workflow-application-print-summary', this.applicationId],
        { relativeTo: this._route.parent }
      );
      setTimeout(() => {
        this.disableSummaryInteractions();
      }, 0);
    } else {
      return;
    }
  }
  applyOverlayStyleToAppView = () => {
    this.context.janusLayout === 'staff' &&
      !this._router.url.includes('workflow-applications') &&
      this.context.applicationViewType === 'overlay';
  };
  private disableSummaryInteractions(): void {
    const cards = document.querySelectorAll('.hover-summary-card');
    cards.forEach((el: any) => {
      el.style.pointerEvents = 'none';
    });

    const footers = document.querySelectorAll(
      '.alert-summary-footer wm-common-button'
    );
    footers.forEach((el: any) => {
      el.style.setProperty(
        '--button-font-color',
        'rgba(153,153,153,0.4)',
        'important'
      );
      el.style.pointerEvents = 'none';
    });
  }

  get roleDropdownOptions() {
    return (this.testRoles || []).map(role => ({
      label: role.name,
      value: role.id
    }));
  }
  isApplyForPermitRoute = false;

  setVoidMenuWidth(wrapper: HTMLElement): void {
    setTimeout(() => {
      const panels = document.querySelectorAll('.mat-mdc-menu-panel');
      const panel = panels[panels.length - 1] as HTMLElement;

      if (panel && wrapper) {
        const width = wrapper.offsetWidth;

        panel.style.width = width + 'px';
        panel.style.minWidth = width + 'px';
        panel.style.maxWidth = width + 'px';
        panel.style.borderRadius = '16px';
        panel.style.overflow = 'hidden';
        panel.style.marginTop = '5px';
      }
    });
  }
  private navigateByUrlWithoutLeavePrompt(url: string): Promise<boolean> {
    this.skipRouteLeaveConfirmationOnce = true;

    return this._router
      .navigateByUrl(url, {
        state: {
          skipAppViewLeaveConfirmation: true
        }
      })
      .finally(() => {
        this.skipRouteLeaveConfirmationOnce = false;
      });
  }
  private returnToContractorTypeEdit(): void {
    const returnUrl =
      this.returnURL ||
      this._route.snapshot.queryParamMap.get('returnURL') ||
      this.context.applicationReturnURL;

    if (!returnUrl) {
      console.error('Test Contractor Workflow Return URL is not available.');
      return;
    }

    this.context.applicationViewType = 'none';
    this.context.applicationViewType$.emit('none');

    this.context.applicationId = null;
    this.context.applicationId$.emit(null);

    this.navigateByUrlWithoutLeavePrompt(returnUrl);
  }
  private closeContractorRenewalInline(): void {
    this.activityDataId = null;

    this.context.applicationViewType = 'none';
    this.context.applicationViewType$.emit('none');

    this.context.applicationId = null;
    this.context.applicationId$.emit(null);

    if (!this.isJanusContractorRegistration) {
      return;
    }

    this.navigateWithoutLeavePrompt([], {
      relativeTo: this._route,
      queryParams: {
        id: null,
        registrationId: null,
        view: null,
        showAppView: null,
        workflowId: null,
        workflowVersionId: null,
        isTest: null,
        skipActivityNavigation: null,
        activityDataId: null,
        cid: null,
        isChild: null,
        isLinkedApp: null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
}
